import React, { Component } from 'react'
import './Center.css'
import YearList from '../YearList'
import { HOST } from "../../config";

export default class Center extends Component {
    constructor(props) {
        super(props);
        this.state = {
            SearchName: [],
            SearchNameSt: [],
            s_fio_document: null,
            filteredData: [],
            yearOption: 0,
            facultyOption: 0,
            educOption: 0,
            rateOption: 0,
            groupoption: 0,
            application: 0,
            insertRow: 0,
            activerow: 0,
            activerow_ind: -1,
            SureDel: -1,
            pageNum: 1,
            pageStart: 0,
            pageEnd: 0,
            pages: 0,
            StudentListName: [],
            TeachersList: [],
            id_rate: this.props.id_rate,
            visible: false,
            id_faculty: 0,
            Tr_hover: -1,
            new_st_fio: null,
            selected_s_fio: null,
            selected_student_id: null,
            id_academ_document_type: null,
            new_uni_number: null,
            new_reg_number: null,
            give_date: null,
            openDocRegStlist: false,
            setAcademKG: '',
            setAcademEN: '',
            typeofacademSettings: 0,
            Some_proporties_checked: 0,
            openUserlist: false,
            okno_role_type: 0,
            okno_title_new: null,
            okno_Description_new: null,
            visibility: false,


            ckb: false,
            dekanat: false,
            KjMTB: false,
            obshejitie: false,
            biblioteka: false,
            Buhgalteriy: false,
            pole1: false,
            pole2: false,
            pole3: false
        }
    }

    componentDidMount() {
        this.setState({
            TeachersList: this.props.TeachersList,
            StudentListName: this.props.StudentListName,
        })
    }
    componentDidUpdate(prevProps) {
        if (prevProps.id_a_year > 0 && prevProps.id_a_year !== this.props.id_a_year) {
            this.ChangeFaculty(0)
        }
        if (prevProps.id_faculty > 0 && prevProps.id_faculty !== this.props.id_faculty) {
            this.ChangeEduc(0)
        }
        if (prevProps.id_f_educ > 0 && prevProps.id_f_educ !== this.props.id_f_educ) {
            this.ChangeRate(0)
        }
        if (prevProps.selected_menu !== this.props.selected_menu) {
            this.setState({ SearchName: [], filteredData: [] })
        }
        if (prevProps.StudentListName !== this.props.StudentListName) {
            this.setState({ StudentListName: this.props.StudentListName })
        }
        if (prevProps.selected_menu !== this.props.selected_menu) {
            this.setState({
                SearchName: [],
                SearchNameSt: [],
                s_fio_document: null,
                filteredData: [],
                yearOption: 0,
                facultyOption: 0,
                educOption: 0,
                rateOption: 0,
                groupoption: 0,
                application: 0,
                insertRow: 0,
                activerow: 0,
                activerow_ind: -1,
                SureDel: -1,
                pageNum: 1,
                pageStart: 0,
                pageEnd: 0,
                pages: 0,
                StudentListName: [],
                TeachersList: [],
                id_rate: this.props.id_rate,
                visible: false,
                id_faculty: 0,
                Tr_hover: -1,
                new_st_fio: null,
                selected_s_fio: null,
                selected_student_id: null,
                id_academ_document_type: null,
                new_uni_number: null,
                new_reg_number: null,
                give_date: null,
                openDocRegStlist: false,
                setAcademKG: null,
                setAcademEN: null,
                typeofacademSettings: 0,
                Some_proporties_checked: 0,
                openUserlist: false,
                okno_role_type: 0,
            })
        }
    }
    postStudentListName(id_AVN_User, SearchNameSt) {
        this.props.postStudentListName(id_AVN_User, SearchNameSt)
    }
    SelectSearchType(search_type) {
        this.props.SelectSearchType(search_type)
        this.setState({ SearchNameSt: [] });
    }
    onSearchClick = () => {
        if (this.state.SearchNameSt && this.state.SearchNameSt.length) {
            this.postStudentListName(this.props.id_AVN_User, this.state.SearchNameSt)
        }
        if (this.props.selected_menu === 3 && this.state.s_fio_document && this.state.s_fio_document.length) {
            this.postReportApplicationDone(this.state.s_fio_document)
        }
        if (this.props.selected_menu === 4 && this.state.s_fio_document && this.state.s_fio_document.length) {
            this.postAcademDocRegTable(0, this.state.s_fio_document)
        }
        if (this.props.selected_menu === 5 && this.props.applicationType === 1 &&
            this.state.s_fio_document && this.state.s_fio_document.length) {
            if (this.state.typeofacademSettings === 0) {
                this.props.postDirectionList(this.state.s_fio_document, 1)
            }
            if (this.state.typeofacademSettings === 1) {
                this.props.postSpecialList(this.state.s_fio_document, 1)
            }
            if (this.state.typeofacademSettings === 2) {
                this.props.postDisciplineList(this.state.s_fio_document, 1)
            }
        }
    }
    onCloseClick = () => {
        this.setState({ SearchName: '', filteredData: [], SearchNameSt: '', StudentListName: [], s_fio_document: '' });
        if (this.props.selected_menu === 4) {
            this.postAcademDocRegTable(0, null)
        }
        if (this.props.selected_menu === 5) {
            if (this.state.typeofacademSettings === 0) {
                this.props.postDirectionList(null, 1)
            }
            if (this.state.typeofacademSettings === 1) {
                this.props.postSpecialList(null, 1)
            }
            if (this.state.typeofacademSettings === 2) {
                this.props.postDisciplineList(null, 1)
            }
        }
    }
    onChangeBoundStudent = (event) => {
        this.setState({ SearchNameSt: event.target.value });
        // let newStr = []
        // if (event.target.value && event.target.value !== null && event.target.value !== ' ') {
        //     newStr = event.target.value[0].toUpperCase() + event.target.value.slice(1)
        //     const filteredDataSt = this.state.StudentList.filter(item => item.s_fio.includes(newStr) + item.s_fio.includes(event.target.value))
        //     this.setState({ filteredDataSt });
        //     console.log("filteredData", filteredDataSt)
        // }
    }
    onChangeBoundApplication = (event) => {
        this.setState({ s_fio_document: event.target.value });
    }
    onChangeBound = (event) => {
        this.setState({ SearchName: event.target.value });
        let newStr = []

        if (event.target.value && event.target.value !== null && event.target.value !== ' ') {
            newStr = event.target.value[0].toUpperCase() + event.target.value.slice(1)
            const filteredData = this.props.TeachersList.filter(item => item.t_fio.includes(newStr) + item.t_fio.includes(event.target.value))
            this.setState({ filteredData });
        }
    }
    OpenSelectorOptions = (yearOption, facultyOption, educOption, rateOption, groupoption, application) => {
        this.setState({ yearOption, facultyOption, educOption, rateOption, groupoption, application })
    }
    ChangeYear = (id_a_year, name) => {
        this.props.ChangeYear(id_a_year, name);
        this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)
    }
    ChangeFaculty = (id_faculty, faculty_name) => {
        this.props.ChangeFaculty(id_faculty, faculty_name);
        this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)
    }
    ChangeEduc = (id_f_educ, f_educ) => {
        this.props.ChangeEduc(id_f_educ, f_educ);
        this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)
    }
    ChangeRate = (id_rate) => {
        this.props.ChangeRate(id_rate);
        this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)
    }
    ChangeGroup = (id_group, group_name) => {
        this.props.ChangeGroup(id_group, group_name);
        this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)
    }
    SelectStudent(id_student, id_group, id_protocols, id_rate, id_faculty) {

        this.props.SelectStudent(id_student, id_group, id_protocols, id_rate, id_faculty)
        this.setState({ visible: false })
        this.setState({
            id_group,
            id_faculty
        })
    }
    ContextMenuStudent(event, id_student, id_group, id_protocols, id_rate, id_faculty) {
        // alert(id_group)
        event.preventDefault();
        const elHeight = document.getElementById('Context')
        const clickX = event.clientX;
        const clickY = event.clientY;
        this.setState({ visible: true, x: clickX, y: clickY, selected_student_id: id_student, elHeight: elHeight });
        this.props.SelectStudent(id_student, id_group, id_protocols, id_rate, id_faculty)
        this.setState({
            id_group,
            id_faculty,
        })
    }
    ContextMenuClose() {
        this.setState({ visible: false })
    }
    openPaymentReport(paymentReport) {
        this.props.openPaymentReport(paymentReport)
    }
    OpenReportsPage = (reportsPage, reportType, id_student, id_group, id_faculty, id_raion, id_protocols, id_okno_zakaz) => {
        this.props.OpenReportsPage(reportsPage, reportType, id_student, id_group, id_faculty, id_raion, id_protocols, id_okno_zakaz)
        this.setState({ visible: false })
    }
    SelectTeacher(id_teacher, s_t_fio) {
        this.props.SelectTeacher(id_teacher, s_t_fio)
    }

    //////////////////////////////////////////////////////////////////////
    // Applications
    //////////////////////////////////////////////////////////////////////
    postReportApplicationDone = (s_fio_document) => {
        this.props.postReportApplicationDone(s_fio_document)
    }
    SelectApplicationType = (applicationType) => {
        this.props.SelectApplicationType(applicationType)
        this.setState({
            s_fio_document: '',
            setAcademKG: null,
            setAcademEN: null,
            activerow: 0
        })
    }
    ChangeReportType = (reportType, report) => {
        this.props.ChangeReportType(reportType, report)
        this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)
    }
    OnChangeStatusApplication = (e) => {
        this.props.OnChangeStatusApplication(e);
    };
    changeStyleTr(Tr_hover) {
        this.setState({
            Tr_hover
        })
    }

    /////////////////////////////////////////////////////////////////////////
    activeUpdateRow(activerow, activerow_ind) {
        this.setState({ activerow, activerow_ind })
        if (activerow === 0) {
            this.setState({
                new_st_fio: null,
                selected_s_fio: null,
                id_academ_document_type: null,
                new_uni_number: null,
                new_reg_number: null,
                give_date: null,
                setAcademKG: null,
                setAcademEN: null,
                Some_proporties_checked: 0,
                okno_title_new: null,
                okno_Description_new: null,
                visibility: false,

                ckb: false,
                dekanat: false,
                KjMTB: false,
                obshejitie: false,
                biblioteka: false,
                Buhgalteriy: false,
                pole1: false,
                pole2: false,
                pole3: false
            })
        }
        if (this.props.selected_menu === 6 && this.props.applicationType === 0 && activerow === 1 && this.state.okno_role_type === 0) {
            const { Okno_role } = this.props
            this.setState({
                ckb: this.state.ckb === false && Okno_role[activerow_ind].ckb === true ? true : false,
                dekanat: this.state.dekanat === false && Okno_role[activerow_ind].dekanat === true ? true : false,
                KjMTB: this.state.KjMTB === false && Okno_role[activerow_ind].KjMTB === true ? true : false,
                obshejitie: this.state.obshejitie === false && Okno_role[activerow_ind].obshejitie === true ? true : false,
                biblioteka: this.state.biblioteka === false && Okno_role[activerow_ind].biblioteka === true ? true : false,
                Buhgalteriy: this.state.Buhgalteriy === false && Okno_role[activerow_ind].Buhgalteriy === true ? true : false,
                pole1: this.state.pole1 === false && Okno_role[activerow_ind].pole1 === true ? true : false,
                pole2: this.state.pole2 === false && Okno_role[activerow_ind].pole2 === true ? true : false,
                pole3: this.state.pole3 === false && Okno_role[activerow_ind].pole3 === true ? true : false,
            })

        }
        if (this.props.selected_menu === 6 && this.props.applicationType === 0 && activerow === 1 && this.state.okno_role_type === 1) {
            const { Okno_role_teacher } = this.props
            this.setState({
                ckb: this.state.ckb === false && Okno_role_teacher[activerow_ind].t_fio_pole1 === true ? true : false,
                dekanat: this.state.dekanat === false && Okno_role_teacher[activerow_ind].t_fio_pole2 === true ? true : false,
                KjMTB: this.state.KjMTB === false && Okno_role_teacher[activerow_ind].t_fio_pole3 === true ? true : false,
                obshejitie: this.state.obshejitie === false && Okno_role_teacher[activerow_ind].t_fio_pole4 === true ? true : false,
                biblioteka: this.state.biblioteka === false && Okno_role_teacher[activerow_ind].t_fio_pole5 === true ? true : false,
                Buhgalteriy: this.state.Buhgalteriy === false && Okno_role_teacher[activerow_ind].t_fio_pole6 === true ? true : false,
                pole1: this.state.pole1 === false && Okno_role_teacher[activerow_ind].t_fio_pole7 === true ? true : false,
                pole2: this.state.pole2 === false && Okno_role_teacher[activerow_ind].t_fio_pole8 === true ? true : false,
                pole3: this.state.pole3 === false && Okno_role_teacher[activerow_ind].t_fio_pole9 === true ? true : false,
            })

            // setTimeout(() => {
            //     console.log('activerow', ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3)
            // }, 10);

        }
        if (this.props.selected_menu === 6 && this.props.applicationType === 1 && activerow === 1) {
            if (this.state.okno_role_type === 0) {
                this.setState({
                    visibility: this.props.Okno_proporties_list[activerow_ind].visibility === true ? true : false
                })
            } else if (this.state.okno_role_type === 1) {
                this.setState({
                    visibility: this.props.Okno_proporties_list[9 + activerow_ind].visibility === true ? true : false
                })
            }
        }
    }
    plusInsertRow(insertRow) {
        this.setState({ insertRow })
        this.setState({
            new_st_fio: null,
            selected_s_fio: null,
            id_academ_document_type: null,
            new_uni_number: null,
            new_reg_number: null,
            give_date: null,
            activerow_ind: -1
        })
    }
    onChangeFio = (e) => {
        if (e.target.value) {
            let new_st_fio = e.target.value[0].toUpperCase() + e.target.value.slice(1)
            this.setState({ new_st_fio: new_st_fio })
        }
        if (!e.target.value) {
            this.props.postDocumentRegSTlist(e.target.value)
            this.setState({
                openDocRegStlist: false
            })
        }
    }
    openDocREgStudentlist = () => {
        this.props.postDocumentRegSTlist(this.state.new_st_fio)
        setTimeout(() => {
            this.setState(prevState => ({
                openDocRegStlist: !prevState.openDocRegStlist
            }));
        }, 200);
    }
    closeDocREgStudentlist() {
        this.setState({
            openDocRegStlist: false
        })
    }
    SelectStudentFio(selected_s_fio, selected_id_student) {
        this.setState({
            selected_s_fio, selected_id_student
        })
        setTimeout(() => {
            this.setState({
                openDocRegStlist: false,
                openUserlist: false
            })
        }, 10);
    }
    onSelectDocument = (e) => {
        this.setState({ id_academ_document_type: e.target.value })
    }
    onChangeUniNumber = (e) => {
        this.setState({ new_uni_number: e.target.value })
    }
    onChangeRegNumber = (e) => {
        this.setState({ new_reg_number: e.target.value })
    }
    onChangeDateGive = (e) => {
        if (e.target.value && e.target.value.length) {
            // const give_date = e.target.value.split('-')[2] + '.' + e.target.value.split('-')[1] + '.' + e.target.value.split('-')[0]
            this.setState({ give_date: e.target.value })
        }
    }
    SaveInsertedDocRow() {
        this.postacAdemDocRegTableInsert(
            this.state.selected_id_student,
            this.state.id_academ_document_type,
            this.state.new_uni_number ? this.state.new_uni_number : null,
            this.state.new_reg_number ? this.state.new_reg_number : null,
            this.state.give_date,
            this.props.id_AVN_User)
        setTimeout(() => {
            this.setState({
                new_st_fio: null,
                selected_s_fio: null,
                id_academ_document_type: null,
                new_uni_number: null,
                new_reg_number: null,
                give_date: null,
                insertRow: 0,
                activerow_ind: -1
            })
        }, 30);
    }
    SaveUpdatedDocRow(index, id_akadem_document) {
        const { AcademDocRegTable } = this.props
        this.props.postAcademDocRegTableUpdate(
            this.state.selected_id_student ? this.state.selected_id_student : AcademDocRegTable[index].id_student,
            this.state.id_academ_document_type ? this.state.id_academ_document_type : AcademDocRegTable[index].id_akadem_document_type,
            this.state.new_uni_number ? this.state.new_uni_number : this.state.new_uni_number && this.state.new_uni_number.length === 0 ? null : AcademDocRegTable[index].document_numer,
            this.state.new_reg_number ? this.state.new_reg_number : this.state.new_reg_number && this.state.new_reg_number.length === 0 ? null : AcademDocRegTable[index].document_reg_numer,
            this.state.give_date ? this.state.give_date : AcademDocRegTable[index].document_date && AcademDocRegTable[index].document_date.split('.')[2] + '-' + AcademDocRegTable[index].document_date.split('.')[1] + '-' + AcademDocRegTable[index].document_date.split('.')[0],
            id_akadem_document)
        setTimeout(() => {
            this.setState({
                new_st_fio: null,
                selected_s_fio: null,
                selected_student_id: null,
                id_academ_document_type: null,
                new_uni_number: null,
                new_reg_number: null,
                give_date: null,
                activerow: 0,
                activerow_ind: -1
            })
        }, 30);
    }
    sureDelete(SureDel) {
        this.setState({ SureDel })
    }
    SureDeleteDocRow(id_academ_document) {
        this.props.postacAdemDocRegTableDelete(id_academ_document)
        setTimeout(() => {
            this.setState({
                SureDel: -1
            })
        }, 20);
    }
    postacAdemDocRegTableInsert = (selected_id_student, id_academ_document_type, new_uni_number, new_reg_number, give_date, id_AVN_User) => {
        this.props.postacAdemDocRegTableInsert(selected_id_student, id_academ_document_type, new_uni_number, new_reg_number, give_date, id_AVN_User)
    }
    postAcademDocRegTableUpdate = (selected_id_student, id_academ_document_type, new_uni_number, new_reg_number, give_date, id_akadem_document) => {
        this.props.postAcademDocRegTableUpdate(selected_id_student, id_academ_document_type, new_uni_number, new_reg_number, give_date, id_akadem_document)
    }
    postAcademDocRegTable = (reportType, s_fio_document) => {
        this.props.postAcademDocRegTable(reportType, s_fio_document)
    }


    /////////////////////////////Discipline___Settings//////////////////////////////////////////////

    AcademReffSettings(typeofacademSettings) {
        this.setState({ typeofacademSettings })
        if (typeofacademSettings === 0) {
            this.props.postDirectionList(null, 1)
        }
        if (typeofacademSettings === 1) {
            this.props.postSpecialList(null, 1)
        }
        if (typeofacademSettings === 2) {
            this.props.postDisciplineList(null, 1)
        }
        setTimeout(() => {
            this.setState({
                setAcademKG: null,
                setAcademEN: null,
                activerow: 0,
                activerow_ind: -1,
                s_fio_document: '',
                pageNum: 1
            })
        }, 30);
    }
    //   postSpecialUpdate
    //   postDirectionUpdate
    onChangeAcademKG = (e) => {
        this.setState({ setAcademKG: e.target.value ? e.target.value : '' })
    }
    onChangeAcademEN = (e) => {
        this.setState({ setAcademEN: e.target.value ? e.target.value : '' })
    }
    SaveUpdatedAcademReffSets(index, id) {
        if (this.props.applicationType === 1 && this.state.typeofacademSettings === 1) {
            if (this.state.setAcademKG && this.state.setAcademEN) {
                this.props.postSpecialUpdate(this.props.id_AVN_User, this.state.setAcademKG, this.state.setAcademEN, id, this.state.s_fio_document, this.state.pageNum)
            }
            if (this.state.setAcademKG && !this.state.setAcademEN) {
                this.props.postSpecialUpdate(this.props.id_AVN_User, this.state.setAcademKG, this.props.SpecialList[index].p25_2_en, id, this.state.s_fio_document, this.state.pageNum)
            }
            if (!this.state.setAcademKG && this.state.setAcademEN) {
                this.props.postSpecialUpdate(this.props.id_AVN_User, this.props.SpecialList[index].p25_2k, this.state.setAcademEN, id, this.state.s_fio_document, this.state.pageNum)
            }

        } else if (this.props.applicationType === 1 && this.state.typeofacademSettings === 0) {
            if (this.state.setAcademKG && this.state.setAcademEN) {
                this.props.postDirectionUpdate(this.props.id_AVN_User, this.state.setAcademKG, this.state.setAcademEN, id, this.state.s_fio_document, this.state.pageNum)
            }
            if (this.state.setAcademKG && !this.state.setAcademEN) {
                this.props.postDirectionUpdate(this.props.id_AVN_User, this.state.setAcademKG, this.props.DirectionList[index].p24_2_en, id, this.state.s_fio_document, this.state.pageNum)
            }
            if (!this.state.setAcademKG && this.state.setAcademEN) {
                this.props.postDirectionUpdate(this.props.id_AVN_User, this.props.DirectionList[index]['p24-2_kg'], this.state.setAcademEN, id, this.state.s_fio_document, this.state.pageNum)
            }
        } else if (this.props.applicationType === 1 && this.state.typeofacademSettings === 2) {
            if (this.state.setAcademKG && this.state.setAcademEN) {
                this.props.postDisciplineUpdate(this.props.id_AVN_User, this.state.setAcademKG, this.state.setAcademEN, id, this.state.s_fio_document, this.state.pageNum)
            }
            if (this.state.setAcademKG && !this.state.setAcademEN) {
                this.props.postDisciplineUpdate(this.props.id_AVN_User, this.state.setAcademKG, this.props.DisciplineList[index].p34_en, id, this.state.s_fio_document, this.state.pageNum)
            }
            if (!this.state.setAcademKG && this.state.setAcademEN) {
                this.props.postDisciplineUpdate(this.props.id_AVN_User, this.props.DisciplineList[index].p34_kg, this.state.setAcademEN, id, this.state.s_fio_document, this.state.pageNum)
            }
        }
        if (this.props.applicationType === 0) {

            if (this.state.setAcademKG && this.state.setAcademEN) {
                this.props.postOkno_dopolnitelnoUpdate(this.state.setAcademKG, this.state.setAcademEN, id)
            }
            if (this.state.setAcademKG && !this.state.setAcademEN) {
                this.props.postOkno_dopolnitelnoUpdate(this.state.setAcademKG, this.props.Okno_dopolnitelno[index].insert_pole_kg, id)
            }
            if (!this.state.setAcademKG && this.state.setAcademEN) {
                this.props.postOkno_dopolnitelnoUpdate(this.props.Okno_dopolnitelno[index].insert_pole, this.state.setAcademEN, id)
            }
            if (!this.state.setAcademKG && !this.state.setAcademEN) {
                this.props.postOkno_dopolnitelnoUpdate(this.state.setAcademKG, this.state.setAcademEN, id)
            }
        }



        setTimeout(() => {
            this.setState({
                setAcademKG: null,
                setAcademEN: null,
                activerow: 0,
                activerow_ind: -1
            })
        }, 30);
    }

    GoToPage(pageNum) {
        this.setState({
            pageNum
        })
        if (this.state.typeofacademSettings === 0) {
            this.props.postDirectionList(null, pageNum)
            this.setState({
                pageStart: this.props.DirectionList[0].pageStart,
                pageEnd: this.props.DirectionList[0].pageENd,
                pages: this.props.DirectionList[0].pages,
                total: this.props.DirectionList[0].total
            })

        }
        if (this.state.typeofacademSettings === 1) {
            this.props.postSpecialList(null, pageNum)
            this.setState({
                pageStart: this.props.SpecialList[0].pageStart,
                pageEnd: this.props.SpecialList[0].pageENd,
                pages: this.props.SpecialList[0].pages,
                total: this.props.SpecialList[0].total
            })
        }
        if (this.state.typeofacademSettings === 2) {
            this.props.postDisciplineList(null, pageNum)
            this.setState({
                pageStart: this.props.DisciplineList[0].pageStart,
                pageEnd: this.props.DisciplineList[0].pageEnd,
                pages: this.props.DisciplineList[0].pages,
                total: this.props.DisciplineList[0].total
            })
        }
    }
    /////////////////////////////Razreshenie___Settings___Student//////////////////////////////////////////////
    SelectOknoRoleType(okno_role_type) {
        this.setState({ okno_role_type })
        setTimeout(() => {
            this.setState({
                activerow: 0,
                activerow_ind: -1,
                insertRow: 0,
            })
        }, 30);
    }
    onChangeUserFio = (e) => {
        if (e.target.value) {
            let new_st_fio = e.target.value[0].toUpperCase() + e.target.value.slice(1)
            this.setState({ new_st_fio: new_st_fio })
        }
        if (!e.target.value) {
            this.props.postDocumentRegSTlist(e.target.value)
            this.setState({
                openUserlist: false
            })
        }
    }
    openUserList = () => {
        if (this.state.openUserlist === false) {
            this.props.postUserList(this.state.new_st_fio)
        }
        setTimeout(() => {
            this.setState(prevState => ({
                openUserlist: !prevState.openUserlist
            }));
        }, 200);
    }
    closeUserList() {
        this.setState({
            openUserlist: false
        })
    }
    postUserList(userName) {
        this.props.postUserList(userName)
    }

    ChangeProporties1 = () => {
        this.setState(({ ckb }) => ({ ckb: !ckb, Some_proporties_checked: 1 }));
    }
    ChangeProporties2 = () => {
        this.setState(({ dekanat }) => ({ dekanat: !dekanat, Some_proporties_checked: 1 }));
    }
    ChangeProporties3 = () => {
        this.setState(({ KjMTB }) => ({ KjMTB: !KjMTB, Some_proporties_checked: 1 }));
    }
    ChangeProporties4 = () => {
        this.setState(({ obshejitie }) => ({ obshejitie: !obshejitie, Some_proporties_checked: 1 }));
    }
    ChangeProporties5 = () => {
        this.setState(({ biblioteka }) => ({ biblioteka: !biblioteka, Some_proporties_checked: 1 }));
    }
    ChangeProporties6 = () => {
        this.setState(({ Buhgalteriy }) => ({ Buhgalteriy: !Buhgalteriy, Some_proporties_checked: 1 }));
    }
    ChangeProporties7 = () => {
        this.setState(({ pole1 }) => ({ pole1: !pole1, Some_proporties_checked: 1 }));
    }
    ChangeProporties8 = () => {
        this.setState(({ pole2 }) => ({ pole2: !pole2, Some_proporties_checked: 1 }));
    }
    ChangeProporties9 = () => {
        this.setState(({ pole3 }) => ({ pole3: !pole3, Some_proporties_checked: 1 }));
    }
    //---------------------OknoRole____Insert---------------------//
    SaveInsertedOknoRole() {
        setTimeout(() => {
            const { selected_id_student, ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3 } = this.state
            if (this.state.okno_role_type === 0) {
                this.props.postOknoRoleInsert(selected_id_student, ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3)
            } else if (this.state.okno_role_type === 1) {
                this.props.postOknoRoleSotrudnikInsert(selected_id_student, ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3)
            }
        }, 50);

        setTimeout(() => {
            this.setState({
                ckb: false,
                dekanat: false,
                KjMTB: false,
                obshejitie: false,
                biblioteka: false,
                Buhgalteriy: false,
                pole1: false,
                pole2: false,
                pole3: false,
                insertRow: 0,
                activerow_ind: -1,
                new_st_fio: null,
                selected_s_fio: null
            })
        }, 60);
    }
    //---------------------OknoRole____Update---------------------//
    SaveUpdatedOknoRole(index, id) {
        setTimeout(() => {
            const { ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3 } = this.state
            if (this.state.okno_role_type === 0) {
                this.props.postOknoRoleUpdate(ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3, id)
            } else if (this.state.okno_role_type === 1) {
                this.props.postOknoRoleSotrudnikUpdate(ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3, id)
            }
        }, 50);

        setTimeout(() => {
            this.setState({
                ckb: false,
                dekanat: false,
                KjMTB: false,
                obshejitie: false,
                biblioteka: false,
                Buhgalteriy: false,
                pole1: false,
                pole2: false,
                pole3: false,
                activerow: 0,
                activerow_ind: -1
            })
        }, 60);
    }
    //---------------------OknoRole____Delete---------------------//
    SureDeleteOknoRole(id_role_okno) {
        if (this.state.okno_role_type === 0) {
            this.props.postOknoRoleDelete(id_role_okno)
        } else if (this.state.okno_role_type === 1) {
            this.props.postOknoRoleSotrudnikDelete(id_role_okno)
        }
        setTimeout(() => {
            this.setState({
                SureDel: -1
            })
        }, 20);
    }

    onChange_okno_title = (e) => {
        this.setState({ okno_title_new: e.target.value })
    }
    onChange_Description = (e) => {
        this.setState({ okno_Description_new: e.target.value })
    }
    Change_visibility = () => {
        this.setState(({ visibility }) => ({ visibility: !visibility, Some_proporties_checked: 1 }));
    }


    SaveUpdatedOknoProporties(index, id) {
        const { okno_title_new, okno_Description_new, visibility } = this.state
        const { Okno_proporties_list } = this.props
        if (this.state.okno_role_type === 0) {
            if (okno_title_new && okno_Description_new) {
                this.props.postOkno_proporties_list_Update(okno_title_new, okno_Description_new, visibility, id)
            }
            if (okno_title_new && !okno_Description_new) {
                this.props.postOkno_proporties_list_Update(okno_title_new, Okno_proporties_list[index].Description, visibility, id)
            }
            if (!okno_title_new && !okno_Description_new) {
                this.props.postOkno_proporties_list_Update(Okno_proporties_list[index].okno_title, Okno_proporties_list[index].Description, visibility, id)
            }
            if (!okno_title_new && okno_Description_new) {
                this.props.postOkno_proporties_list_Update(Okno_proporties_list[index].okno_title, okno_Description_new, visibility, id)
            }
        } else if (this.state.okno_role_type === 1) {
            if (okno_title_new && okno_Description_new) {
                this.props.postOkno_proporties_list_Update(okno_title_new, okno_Description_new, visibility, id)
            }
            if (okno_title_new && !okno_Description_new) {
                this.props.postOkno_proporties_list_Update(okno_title_new, Okno_proporties_list[9 + index].Description, visibility, id)
            }
            if (!okno_title_new && !okno_Description_new) {
                this.props.postOkno_proporties_list_Update(Okno_proporties_list[9 + index].okno_title, Okno_proporties_list[9 + index].Description, visibility, id)
            }
            if (!okno_title_new && okno_Description_new) {
                this.props.postOkno_proporties_list_Update(Okno_proporties_list[9 + index].okno_title, okno_Description_new, visibility, id)
            }
        }
        setTimeout(() => {
            this.setState({
                okno_title_new: null,
                okno_Description_new: null,
                visibility: false,
                activerow: 0,
                activerow_ind: -1
            })
        }, 60);
    }

    postOkno_proporties_list_Update() {
        this.props.postOkno_proporties_list_Update()
    }
    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.onSearchClick()
            this.openUserList()
            if (this.state.insertRow === 1) {
                this.openDocREgStudentlist()
            }
        }
    }

    render() {
        const { SearchName, SearchNameSt, filteredData, Some_proporties_checked, ckb, dekanat, KjMTB, obshejitie, biblioteka, Buhgalteriy, pole1, pole2, pole3 } = this.state
        if (!filteredData && !filteredData.length) return null
        const {
            EducList,
            Faculty,
            Rate,
            Group,
            StudentList,
            PAYMENT, ReportsList, reportApplicationDone,
            reportApplicationWait, DocumentRegStudentList, AcademDocList, AcademDocRegTable,
            Okno_dopolnitelno, DisciplineList, SpecialList, DirectionList, Properties, PropertiesTeacher,
            Okno_role, Okno_role_teacher, AVN_user_list, Okno_proporties_list } = this.props
        const { StudentListName, selected_s_fio, id_academ_document_type, new_uni_number, new_reg_number, give_date, setAcademKG, setAcademEN, typeofacademSettings, okno_role_type } = this.state
        return (
            <div className="Center_container" onClick={() => this.state.yearOption === 1 || this.state.educOption === 1 ||
                this.state.facultyOption === 1 || this.state.rateOption === 1 || this.state.groupoption === 1 ?
                this.OpenSelectorOptions(0, 0, 0, 0, 0) : null}
                onMouseLeave={() => this.state.yearOption === 1 || this.state.educOption === 1 ||
                    this.state.facultyOption === 1 || this.state.rateOption === 1 || this.state.groupoption === 1 ?
                    this.OpenSelectorOptions(0, 0, 0, 0, 0) : null}>


                {this.props.paymentReport === 1 &&
                    <div className='Spravka_bgrnd'>
                        <div className='PaymentReport Spravka_container'>
                            <div className='Primechanie_header'>
                                <h3>Оплата за обучение</h3>
                                <i className="fas fa-times" onClick={() => this.openPaymentReport(0)}></i>
                            </div>

                            <table>
                                <thead>
                                    <tr>
                                        <th>Уч. год</th>
                                        <th>Курс</th>
                                        <th>Группа</th>
                                        <th>Смета</th>
                                        <th>Оплата</th>
                                        <th>Долг</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {PAYMENT && PAYMENT.length ? PAYMENT[0].map((item, index) => {
                                        return (
                                            <tr>
                                                <td>{item.p32}</td>
                                                <td>{item.id_rate}</td>
                                                <td>{item.p20}</td>
                                                <td>{item.p106}</td>
                                                <td>{Math.trunc(item.sum_opl * 100) / 100}</td>
                                                <td>{Math.trunc(item.dolg * 100) / 100}</td>
                                            </tr>
                                        )
                                    })
                                        :
                                        <tr>
                                            <td colSpan='6'></td>
                                        </tr>
                                    }

                                </tbody>
                            </table>
                        </div>
                    </div>}
                {/* Меню Студенты */}
                {
                    this.props.selected_menu === 1 ?
                        <div className='Student_container' onMouseLeave={() => this.ContextMenuClose()}>
                            <div className='Search_container'>
                                {this.props.search_type === 0 ?
                                    <div className='Search_by_group_active'>
                                        <div className='Search_type'>
                                            <p onClick={() => this.SelectSearchType(0)}>Поиск по группе</p>
                                            <div className='Search_by_name'>
                                                <p onClick={() => this.SelectSearchType(1)}>Поиск по фамильно</p>
                                            </div>
                                        </div>
                                        <div className="selectors_container">
                                            <div>
                                                <p>Учебный год</p>
                                                <div className="selector">
                                                    <h2 className="select" onClick={() => this.state.yearOption === 0 ? this.OpenSelectorOptions(1, 0, 0, 0, 0) :
                                                        this.OpenSelectorOptions(0, 0, 0, 0, 0)} >
                                                        {this.props.id_a_year > 0 ? this.props.name : 'Выберите учебный год'}
                                                    </h2>
                                                    {this.state.yearOption === 1 ?

                                                        <span>
                                                            {YearList.map(({ id, name }, offset) => {
                                                                return (
                                                                    <p
                                                                        style={{ color: this.props.id_a_year === id && '#7F9CF5' }}
                                                                        key={offset} onClick={() => this.ChangeYear(id, name)}>
                                                                        {name}
                                                                    </p>
                                                                )
                                                            })}
                                                        </span> : null}
                                                </div>
                                            </div>
                                            <div>
                                                <p>Факультет</p>
                                                <div className="selector">
                                                    <h2 className="select" onClick={() => this.state.facultyOption === 0 ? this.OpenSelectorOptions(0, 1, 0, 0, 0) :
                                                        this.OpenSelectorOptions(0, 0, 0, 0, 0)}>
                                                        {Faculty !== null && Faculty.length === 1 ? Faculty[0]['p23-1'] : this.props.id_faculty > 0 ? this.props.faculty_name : 'Выберите факультет'}
                                                    </h2>
                                                    {this.state.facultyOption === 1 ?
                                                        <span>
                                                            {Faculty ? Faculty.map((item, index) => (
                                                                <p
                                                                    style={{ color: this.props.id_faculty === item.id_faculty && '#7F9CF5' }}
                                                                    key={'faculty' + index} onClick={() => this.ChangeFaculty(item.id_faculty, item['p23-1'])}>
                                                                    {item['p23-1']}
                                                                </p>
                                                            )) : null}
                                                        </span> : null}
                                                </div>
                                            </div>
                                            <div>
                                                <p>Форма обучения</p>
                                                <div className="selector">
                                                    <h2 className="select" onClick={() => this.state.educOption === 0 ? this.OpenSelectorOptions(0, 0, 1, 0, 0) :
                                                        this.OpenSelectorOptions(0, 0, 0, 0, 0)} >
                                                        {EducList !== null && EducList.length === 1 ? EducList[0].p108 : this.props.id_f_educ > 0 ? this.props.f_educ : 'Выберите форму'}
                                                    </h2>
                                                    {this.state.educOption === 1 ?
                                                        <span>
                                                            {EducList ? EducList.map((educ, index) => (
                                                                <p
                                                                    style={{ color: this.props.id_f_educ === educ.id_f_educ && '#7F9CF5' }}
                                                                    key={'EducList' + index} onClick={() => this.ChangeEduc(educ.id_f_educ, educ.p108)}>
                                                                    {educ.p108}
                                                                </p>
                                                            )) : null}
                                                        </span> : null}
                                                </div>
                                            </div>
                                            <div>
                                                <p>Курс</p>
                                                <div className="selector">
                                                    <h2 className="select" onClick={() => this.state.rateOption === 0 ? this.OpenSelectorOptions(0, 0, 0, 1, 0) :
                                                        this.OpenSelectorOptions(0, 0, 0, 0, 0)} >
                                                        {Rate !== null && Rate.length === 1 ? Rate[0].p22 : this.props.id_rate > 0 ? this.props.id_rate + '-курс' : 'Выберите курс'}
                                                    </h2>
                                                    {this.state.rateOption === 1 ?
                                                        <span>
                                                            {Rate ? Rate.map((rate, index) => (
                                                                <p
                                                                    style={{ color: this.props.id_rate === rate.id_rate && '#7F9CF5' }}
                                                                    key={'rate' + index} onClick={() => this.ChangeRate(rate.id_rate)}>
                                                                    {rate.p22}
                                                                </p>
                                                            )) : null}
                                                        </span> : null}
                                                </div>
                                            </div>
                                            <div>
                                                <p>Группа</p>
                                                <div className="selector">
                                                    <h2 className="select" onClick={() => this.state.groupoption === 0 ? this.OpenSelectorOptions(0, 0, 0, 0, 1) :
                                                        this.OpenSelectorOptions(0, 0, 0, 0, 0)} >
                                                        {this.props.id_group > 0 ? this.props.group_name : 'Выберите группу'}
                                                    </h2>
                                                    {this.state.groupoption === 1 ?
                                                        <span>
                                                            {Group ? Group.map((group, index) => (
                                                                <p
                                                                    style={{ color: this.props.id_group === group.p20 && '#7F9CF5' }}
                                                                    key={'group' + index} onClick={() => this.ChangeGroup(group.id_group, group.p20)}>
                                                                    {group.p20}
                                                                </p>
                                                            )) : null}
                                                        </span> : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div> :
                                    <div className='Search_by_name_active'>
                                        <div className='Search_by_group'>
                                            <p onClick={() => this.SelectSearchType(0)}>Поиск по группе</p>
                                        </div>
                                        <p className='Search_by_name_active_p' onClick={() => this.SelectSearchType(1)}>Поиск по фамильно</p>
                                        <div className='search_container Student'>
                                            <input
                                                className="search-input"
                                                onChange={this.onChangeBoundStudent}
                                                type="text"
                                                pattern="^[А-Яа-яЁё\s]+$"
                                                value={SearchNameSt}
                                                onKeyPress={this.handleKeyPress} />
                                            <label
                                                className="search-button"
                                                type="button"
                                                aria-label="search button"
                                                style={{ cursor: 'default' }}
                                                onClick={() => this.onSearchClick()}
                                            >
                                                <i className="fab fa-sistrix" ></i>
                                            </label>
                                            {this.state.SearchNameSt && this.state.SearchNameSt.length ?
                                                <label
                                                    className="search-button"
                                                    type="button"
                                                    aria-label="search button"
                                                    onClick={this.onCloseClick}
                                                >
                                                    <i className="fas fa-times-circle"></i>
                                                </label> : null}


                                        </div>
                                    </div>
                                }
                            </div>
                            <div>
                                {this.state.visible &&
                                    <div id='Context' className="contextMenu" style={{ position: "absolute", top: `${this.state.y - (this.state.elHeight && this.state.elHeight.clientHeight)}px`, left: `${this.state.x + 5}px` }}>
                                        {/* <p>Личная карточка студента</p> */}
                                        <p onClick={() => this.OpenReportsPage(1, 1, this.props.id_student, this.props.id_group, this.props.id_faculty, this.props.id_raion, this.props.id_protocols)}>Обходной лист</p>
                                        <p onClick={() => this.openPaymentReport(1)}>Оплата за обучение</p>
                                        <p onClick={() => this.OpenReportsPage(1, 5, this.props.id_student, this.props.id_group, this.props.id_faculty, this.props.id_raion, this.props.id_protocols)}>Справка об окончании</p>
                                        <p onClick={() => this.OpenReportsPage(1, 4, this.props.id_student, this.props.id_group, this.state.id_faculty, this.props.id_raion, this.props.id_protocols)}>Справка об обучении</p>
                                        {/* <p>
                                            <a target="_blank"
                                                rel="noreferrer"
                                                href={`/?page=Studing&st=${this.props.id_student}&gr=${this.state.id_group}&fct=${this.state.id_faculty}`}>
                                                Справка об обучении2
                                            </a>
                                        </p>                                     */}
                                            {/* <p>Выписка о зачислении</p>
                                        <p>Выписка об отчислении </p> */}
                                        {this.props.AVN_BT_report === 1 &&
                                            <p>
                                                <a target="_blank"
                                                    rel="noreferrer"
                                                    href={`${HOST}/api/page?user=${this.props.id_AVN_User}&id=${this.props.id_student}&gid=${this.props.id_group}`}>
                                                    Академическая справка
                                                </a>
                                            </p>
                                        }
                                        {this.props.AVN_BT_report === 1 &&
                                            <p>
                                                <a target="_blank"
                                                    rel="noreferrer"
                                                    href={`/?page=Transcript&st=${this.props.id_student}&gr=${this.state.id_group}`}>
                                                    Транскрипт
                                                </a>
                                            </p>
                                        }
                                    </div>
                                }
                                <table>

                                    <thead>
                                        <tr>
                                            <th style={{ width: '45px' }}>№</th>
                                            <th>ФИО</th>
                                            <th style={{ width: '30%' }}>Группа</th>
                                        </tr>
                                    </thead>
                                    {this.props.search_type === 0 ?
                                        <tbody>
                                            {StudentList.map((item, index) => {
                                                return (
                                                    <tr onContextMenu={(e) => this.ContextMenuStudent(e, item.id_student, item.id_group, item.id_protocols, item.id_rate, item.id_faculty)}
                                                        key={'Student' + index}
                                                        onClick={(e) => this.SelectStudent(item.id_student, item.id_group, item.id_protocols, item.id_rate, item.id_faculty)}
                                                        className={this.props.id_student === item.id_student ? 'tr_activ' : null}
                                                    >
                                                        <td>{index + 1}</td>
                                                        <td style={{ textAlign: 'left' }}>{item.fio}</td>
                                                        <td>{item.p20}</td>
                                                    </tr>)

                                            })}
                                        </tbody> :
                                        <tbody>
                                            {StudentListName && StudentListName.length ? StudentListName.map((item, index) => {
                                                return (
                                                    <tr key={'Student' + index}
                                                        onContextMenu={(e) => this.ContextMenuStudent(e, item.id_student, item.id_group, item.id_protocols, item.id_rate, item.id_faculty)}
                                                        onClick={(e) => this.SelectStudent(item.id_student, item.id_group, item.id_protocols, item.id_rate, item.id_faculty)}
                                                        className={this.props.id_student === item.id_student ? 'tr_activ' : null}
                                                    >
                                                        <td>{index + 1}</td>
                                                        <td style={{ textAlign: 'left' }}>{item.s_fio}</td>
                                                        <td>{item.p20}</td>
                                                    </tr>)
                                            }) : null}
                                        </tbody>}
                                </table>
                            </div>
                        </div>
                        : null
                }
                {/* Меню Сотрудники */}
                {
                    this.props.selected_menu === 2 ?
                        <div className='Student_container Sotrudnik_container'>
                            <div className='Search_container'>
                                <div className='Search_by_name_active'>
                                    <p className='Search_by_name_active_p' onClick={() => this.SelectSearchType(1)}>Поиск сотрудников</p>
                                    <div className='search_container'>
                                        <input
                                            className="search-input"
                                            onChange={this.onChangeBound}
                                            type="text"
                                            value={SearchName}
                                        />

                                        {SearchName.length > 0 && SearchName !== ' ' ?
                                            <label
                                                className="search-button"
                                                type="button"
                                                aria-label="search button"
                                                onClick={this.onCloseClick}
                                            >
                                                <i className="fas fa-times-circle"></i>
                                            </label> :
                                            <label
                                                className="search-button"
                                                type="button"
                                                aria-label="search button"
                                                style={{ cursor: 'default' }}
                                            >
                                                <i className="fab fa-sistrix" ></i>
                                            </label>
                                        }
                                    </div>
                                </div>
                            </div>
                            <table>
                                <thead>
                                    <tr>
                                        <th style={{ width: '45px' }}>№</th>
                                        <th style={{ textAlign: 'left' }}>ФИО</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.map((item, index) => {
                                        return (
                                            <tr key={'Student' + index} onClick={() => this.SelectTeacher(item.id_teacher, item.t_fio)}
                                                className={this.props.id_teacher === item.id_teacher ? 'tr_activ' : null}
                                            >
                                                <td>{index + 1}</td>
                                                <td style={{ textAlign: 'left' }}>{item.t_fio}</td>
                                            </tr>)
                                    })}
                                </tbody>
                            </table>
                        </div>
                        : null
                }
                {/* Меню Заявки на справки*/}
                {
                    this.props.selected_menu === 3 ?
                        <div onMouseLeave={() => this.state.application === 1 && this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)}>
                            <div className='Application_container' onClick={() => this.state.application === 1 && this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)}>
                                <div className='Application_menu'>
                                    <h3 className={this.props.applicationType === 0 && 'active_left'}
                                        onClick={() => this.SelectApplicationType(0)}><i className="fas fa-hourglass-start"></i> Заявки в ожидании </h3>
                                    <h3 className={this.props.applicationType === 1 && 'active_right'}
                                        onClick={() => this.SelectApplicationType(1)}><i className="fas fa-check-double"></i> Выполненные зaявки </h3>
                                </div>
                                <div className='Application_instruments' >
                                    {this.props.applicationType === 0 ?
                                        <div className="selector">
                                            <h2 className="select" onClick={() => this.state.application === 0 ? this.OpenSelectorOptions(0, 0, 0, 0, 0, 1) :
                                                this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)} >
                                                {this.props.reportType > 0 ? this.props.report : 'Все заявки'}
                                            </h2>
                                            {this.state.application === 1 ?
                                                <span>
                                                    <p style={{ color: this.props.reportType === 0 && '#7F9CF5' }} onClick={() => this.ChangeReportType(0, '')}>Все заявки</p>
                                                    {ReportsList && ReportsList.length && ReportsList.map((reports) => {
                                                        return (
                                                            <p
                                                                style={{ color: this.props.reportType === reports.id_okno_document && '#7F9CF5' }}
                                                                key={reports.id_okno_document + 'report'} onClick={() => this.ChangeReportType(reports.id_okno_document, reports.okno_document)}>
                                                                {reports.okno_document}
                                                            </p>
                                                        )
                                                    })}
                                                </span> : null}
                                        </div> :
                                        <div className='search_container Student'>
                                            <input
                                                className="search-input"
                                                onChange={this.onChangeBoundApplication}
                                                type="text"
                                                pattern="^[А-Яа-яЁё\s]+$"
                                                value={this.state.s_fio_document}
                                                onKeyPress={this.handleKeyPress}
                                            />
                                            <label
                                                className="search-button"
                                                type="button"
                                                aria-label="search button"
                                                style={{ cursor: 'default' }}
                                                onClick={() => this.onSearchClick()}
                                            >
                                                <i className="fab fa-sistrix" ></i>
                                            </label>
                                            {this.state.s_fio_document && this.state.s_fio_document.length ?
                                                <label
                                                    className="search-button"
                                                    type="button"
                                                    aria-label="search button"
                                                    onClick={this.onCloseClick}
                                                >
                                                    <i className="fas fa-times-circle"></i>
                                                </label> : null}


                                        </div>
                                    }
                                </div>
                            </div>
                            <div>
                                {this.props.applicationType === 0 ?
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>№</th>
                                                <th>ФИО</th>
                                                <th>Группа</th>
                                                <th>Документ</th>
                                                <th>Дата зявки</th>
                                                <th>Статус</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reportApplicationWait && reportApplicationWait.length ? reportApplicationWait.map((item, index) => {
                                                return (
                                                    <tr key={index + 'Application'}
                                                        style={{
                                                            cursor: 'default', color: item.date_viewed === null && '#3182CE',
                                                            fontWeight: item.date_viewed === null && '600'
                                                        }}
                                                        onMouseEnter={() => this.changeStyleTr(index)} onMouseLeave={() => this.changeStyleTr(-1)}>
                                                        <td>{index + 1}</td>
                                                        <td style={{ textAlign: 'left' }}>{item.s_fio}</td>
                                                        <td>{item.groups}</td>
                                                        <td style={{ position: 'relative', cursor: 'pointer', padding: '0 20px' }}
                                                            onClick={() => this.OpenReportsPage(item.id_okno_document !== 6 ? 1 : 0, item.id_okno_document, item.id_student, item.id_group, item.id_faculty, item.id_raion, item.id_protocols, item.id_okno_zakaz)}>
                                                            {item.okno_document}
                                                            <i style={{ color: this.state.Tr_hover === index && '#aaa', transition: 'all 0.3s ease' }}
                                                                className="fas fa-external-link-alt"></i>
                                                        </td>
                                                        <td>{item.date_insert}</td>
                                                        <td style={{ zIndex: '999', padding: '0px', position: 'relative' }}>
                                                            <label className="Application_checkbox">
                                                                {item.date_viewed === null ?
                                                                    'Новое!' :
                                                                    <input
                                                                        className="checkbox"
                                                                        style={{ cursor: "pointer" }}
                                                                        type="checkbox"
                                                                        onChange={this.OnChangeStatusApplication}
                                                                        defaultValue={item.status}
                                                                        value={item.id_okno_zakaz}
                                                                        id={item.status}
                                                                    />}
                                                            </label>
                                                        </td>
                                                    </tr>
                                                )
                                            }) :
                                                null
                                            }

                                        </tbody>
                                    </table> :
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>№</th>
                                                <th>ФИО</th>
                                                <th>Группа</th>
                                                <th>Документ</th>
                                                <th>Дата зявки</th>
                                                <th>Дата выполнения</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reportApplicationDone && reportApplicationDone.length ? reportApplicationDone.map((item, index) => {
                                                return (
                                                    <tr key={index + 'ApplicationDone'}
                                                        onMouseEnter={() => this.changeStyleTr(index)} onMouseLeave={() => this.changeStyleTr(-1)}
                                                        onClick={() => this.OpenReportsPage(item.id_okno_document !== 6 ? 1 : 0, item.id_okno_document, item.id_student, item.id_group, item.id_faculty, item.id_raion, item.id_protocols, item.id_okno_zakaz)}>
                                                        <td>{index + 1}</td>
                                                        <td style={{ textAlign: 'left' }}>{item.s_fio}</td>
                                                        <td>{item.groups}</td>
                                                        <td style={{ position: 'relative', cursor: 'pointer', padding: '0 20px' }}>
                                                            {item.okno_document}
                                                            <i style={{ color: this.state.Tr_hover === index && '#aaa', transition: 'all 0.3s ease' }}
                                                                className="fas fa-external-link-alt"></i>
                                                        </td>
                                                        <td>{item.date_insert}</td>
                                                        <td>{item.date_update}</td>
                                                    </tr>
                                                )
                                            }) :
                                                null
                                            }

                                        </tbody>
                                    </table>
                                }
                            </div>
                        </div> : null
                }
                {/* Меню Учет Документов*/}
                {
                    this.props.selected_menu === 4 ?
                        <div className='Student_Doc_list'>
                            <div onMouseLeave={() => this.state.application === 1 && this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)}>
                                <div className='Application_container' onClick={() => this.state.application === 1 && this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)}>
                                    <div className='Application_menu'>
                                        <h3 className={this.props.applicationType === 0 && 'active_left'}
                                            onClick={() => this.SelectApplicationType(0)}>Поиск по типу документа</h3>
                                        <h3 className={this.props.applicationType === 1 && 'active_right'}
                                            onClick={() => this.SelectApplicationType(1)}> Поиск по фамилии студента</h3>
                                    </div>
                                    <div className='Application_instruments' >
                                        {this.props.applicationType === 0 ?
                                            <div className="selector">
                                                <h2 className="select" onClick={() => this.state.application === 0 ? this.OpenSelectorOptions(0, 0, 0, 0, 0, 1) :
                                                    this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)} >
                                                    {this.props.reportType > 0 ? this.props.report : 'Все'}
                                                </h2>
                                                {this.state.application === 1 ?
                                                    <span>
                                                        <p style={{ color: this.props.reportType === 0 && '#7F9CF5' }} onClick={() => this.ChangeReportType(0, '')}>Все</p>
                                                        {AcademDocList && AcademDocList.length ? AcademDocList.map((documents) => {
                                                            return (
                                                                <p style={{ color: this.props.reportType === documents.id_akadem_document_type && '#7F9CF5' }}
                                                                    key={documents.id_akadem_document_type + 'document'}
                                                                    onClick={() => this.ChangeReportType(documents.id_akadem_document_type, documents.akadem_document_type)}>{documents.akadem_document_type}</p>
                                                            )
                                                        }) : null}
                                                    </span> : null}
                                            </div> :
                                            <div className='search_container Student'>
                                                <input
                                                    className="search-input"
                                                    onChange={this.onChangeBoundApplication}
                                                    type="text"
                                                    pattern="^[А-Яа-яЁё\s]+$"
                                                    value={this.state.s_fio_document}
                                                    onKeyPress={this.handleKeyPress}
                                                />
                                                <label
                                                    className="search-button"
                                                    type="button"
                                                    aria-label="search button"
                                                    style={{ cursor: 'default' }}
                                                    onClick={() => this.onSearchClick()}
                                                >
                                                    <i className="fab fa-sistrix" ></i>
                                                </label>
                                                {this.state.s_fio_document && this.state.s_fio_document.length ?
                                                    <label
                                                        className="search-button"
                                                        type="button"
                                                        aria-label="search button"
                                                        onClick={this.onCloseClick}
                                                    >
                                                        <i className="fas fa-times-circle"></i>
                                                    </label> : null}
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <table>
                                <thead>
                                    <tr>
                                        <th>№</th>
                                        <th style={{ width: '30%', textAlign: 'center' }}>ФИО</th>
                                        <th style={{ textAlign: 'center', width: '17%' }}>Документ</th>
                                        <th>Уникальный номер</th>
                                        <th>Регистрационный номер</th>
                                        <th style={{ width: '11%' }}>Дата выдачи</th>
                                        <th style={{ minWidth: '80px' }}><i className="fas fa-plus" onClick={() => this.plusInsertRow(1)}></i></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className='insert_row' style={{ position: 'relative' }} onMouseLeave={() => this.closeDocREgStudentlist()}>
                                        {this.state.insertRow === 1 &&
                                            <td>#
                                            </td>}
                                        {this.state.insertRow === 1 &&
                                            <td style={{ position: 'relative' }}>
                                                <input
                                                    onChange={this.onChangeFio}
                                                    // defaultValue={this.state.selected_s_fio}
                                                    value={this.state.selected_s_fio}
                                                    placeholder='Введите ФИО студента'
                                                    style={{ textAlign: 'left' }}
                                                    onKeyPress={this.handleKeyPress}
                                                />
                                                {this.state.new_st_fio !== null && this.state.new_st_fio !== ' ' &&
                                                    <i onClick={() => this.openDocREgStudentlist()} class={this.state.openDocRegStlist === true ? "fas fa-chevron-up" : "fas fa-chevron-down"}></i>}
                                            </td>}
                                        {this.state.insertRow === 1 &&
                                            <td style={{ textAlign: 'center' }}>
                                                <select onChange={this.onSelectDocument}>
                                                    <option value="0">Выберите документ</option>
                                                    {AcademDocList && AcademDocList.length ? AcademDocList.map((documents) => {
                                                        return (
                                                            <option value={documents.id_akadem_document_type}>{documents.akadem_document_type}</option>
                                                        )
                                                    }) : null}
                                                </select>
                                            </td>}
                                        {this.state.insertRow === 1 &&
                                            <td>
                                                <input type='number'
                                                    onChange={this.onChangeUniNumber}
                                                />
                                            </td>}
                                        {this.state.insertRow === 1 &&
                                            <td>
                                                <input type='number'
                                                    onChange={this.onChangeRegNumber}
                                                />
                                            </td>}
                                        {this.state.insertRow === 1 &&
                                            <td>
                                                <input
                                                    type='date'
                                                    onChange={this.onChangeDateGive}
                                                />
                                            </td>}
                                        {this.state.insertRow === 1 &&
                                            <td>
                                                {selected_s_fio && id_academ_document_type && give_date ?
                                                    <i className="fas fa-save" onClick={() => this.SaveInsertedDocRow()}></i> : null}
                                                <i className="fas fa-ban" onClick={() => this.plusInsertRow(0)}></i>
                                            </td>}
                                        {this.state.openDocRegStlist === true &&
                                            <div className='Doc_studentList'>
                                                <li>
                                                    <h4>№</h4>
                                                    <h4>ФИО</h4>
                                                    <h4>Факультет</h4>
                                                    <h4>Группа</h4>
                                                </li>
                                                {DocumentRegStudentList && DocumentRegStudentList.length ? DocumentRegStudentList.map((item, index) => {
                                                    return (
                                                        <li onClick={() => this.SelectStudentFio(item.s_fio, item.id_student)}>
                                                            <p>{index + 1}</p>
                                                            <p>{item.s_fio}</p>
                                                            <p>{item['p23-1']}</p>
                                                            <p>{item.p20}</p>
                                                        </li>
                                                    )
                                                }) : null}
                                            </div>
                                        }

                                    </tr>
                                    {AcademDocRegTable.map((item, index) => (
                                        <tr key={'raion_redact' + index} className={this.state.activerow === 1 && this.state.activerow_ind === index && 'insert_row'}>
                                            <td>{index + 1}</td>
                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', position: 'relative' }}>
                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                    <>
                                                        <input
                                                            style={{ textAlign: 'left' }}
                                                            onChange={this.onChangeFio}
                                                            defaultValue={item.s_fio}
                                                            value={this.state.selected_s_fio}
                                                            onKeyPress={this.handleKeyPress}
                                                        />
                                                        {this.state.new_st_fio !== null && this.state.new_st_fio !== ' ' &&
                                                            <i onClick={() => this.openDocREgStudentlist()} class={this.state.openDocRegStlist === true ? "fas fa-chevron-up" : "fas fa-chevron-down"}></i>}
                                                    </> : item.s_fio
                                                }
                                            </td>
                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'center' }}>

                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                    <select onChange={this.onSelectDocument} style={{ textAlign: 'center' }}>
                                                        <option value="0">Выберите документ</option>
                                                        {AcademDocList && AcademDocList.length ? AcademDocList.map((documents) => {
                                                            return (
                                                                <option key={documents.id_akadem_document_type + 'docOption'}
                                                                    selected={documents.akadem_document_type}
                                                                    value={documents.id_akadem_document_type}>

                                                                    {documents.akadem_document_type}
                                                                </option>
                                                            )
                                                        }) : null}
                                                    </select> : item.akadem_document_type
                                                }
                                            </td>
                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px' }}>
                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                    <input
                                                        type='number'
                                                        onChange={this.onChangeUniNumber}
                                                        defaultValue={item.document_numer}
                                                    /> : item.document_numer
                                                }
                                            </td>
                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px' }}>
                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                    <input
                                                        type='number'
                                                        onChange={this.onChangeRegNumber}
                                                        defaultValue={item.document_reg_numer}
                                                    /> : item.document_reg_numer
                                                }
                                            </td>
                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px' }}>
                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                    <input
                                                        type='date'
                                                        onChange={this.onChangeDateGive}
                                                        defaultValue={item.document_date && item.document_date.split('.')[2] + '-' + item.document_date.split('.')[1] + '-' + item.document_date.split('.')[0]}
                                                    /> : item.document_date
                                                }
                                            </td>

                                            <td >
                                                {
                                                    (selected_s_fio || id_academ_document_type || new_uni_number || new_reg_number || give_date) && this.state.activerow_ind === index ?
                                                        <i className="fas fa-save" onClick={() => this.SaveUpdatedDocRow(index, item.id_akadem_document)}></i> : null
                                                }
                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                    <i className="fas fa-ban" onClick={() => this.activeUpdateRow(0, -1)}></i> :
                                                    <>
                                                        <i className="far fa-edit" onClick={() => this.activeUpdateRow(1, index)}></i>
                                                        <i className="far fa-trash-alt" onClick={() => this.sureDelete(index + 'DocReg')}></i>
                                                    </>}
                                            </td>

                                            {
                                                this.state.SureDel === index + 'DocReg' &&
                                                <div className="Delet_Sure">
                                                    <p>
                                                        <span>Вы действительно хотите удалить запись-</span>
                                                        {item.s_fio}
                                                    </p>
                                                    <label
                                                        className="save_button"
                                                        onClick={() =>
                                                            this.SureDeleteDocRow(item.id_akadem_document)
                                                        }
                                                    >
                                                        <i className="fas fa-trash-alt"> </i>Удалить
                                                    </label>
                                                    <label
                                                        className="cancel_button"
                                                        onClick={() => this.sureDelete(-1)}
                                                    >
                                                        <i className="fas fa-ban"></i>Отмена
                                                    </label>
                                                </div>
                                            }

                                        </tr>
                                    ))
                                    }
                                </tbody>
                            </table>
                        </div> : null
                }
                {/* Меню Справочник*/}
                {
                    this.props.selected_menu === 5 ?
                        <div className='Student_Doc_list Spravochnik'>
                            <div className='Application_container' onClick={() => this.state.application === 1 && this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)}>
                                <div className='Application_menu'>
                                    <h3 className={this.props.applicationType === 0 && 'active_left'}
                                        onClick={() => this.SelectApplicationType(0)}>Ответственные за подписи</h3>
                                    <h3 className={this.props.applicationType === 1 && 'active_right'}
                                        onClick={() => this.SelectApplicationType(1)}>Для академической справки</h3>
                                </div>
                                <div className='Application_instruments' >
                                    {this.props.applicationType === 0 ?
                                        <div className="selector">
                                        </div> :
                                        <div className='Spravochnik_instrumenty'>
                                            <div className="selector">
                                                <h2 className="select" onClick={() => this.state.application === 0 ? this.OpenSelectorOptions(0, 0, 0, 0, 0, 1) :
                                                    this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)} >
                                                    {this.state.typeofacademSettings === 0 ? 'Направления' :
                                                        this.state.typeofacademSettings === 1 ? 'Специальности' :
                                                            this.state.typeofacademSettings === 2 && 'Дисциплины'}
                                                </h2>
                                                {this.state.application === 1 ?
                                                    <span>
                                                        <p style={{ color: this.state.typeofacademSettings === 0 && '#7F9CF5' }}
                                                            onClick={() => this.AcademReffSettings(0)}>Направления</p>
                                                        <p style={{ color: this.state.typeofacademSettings === 1 && '#7F9CF5' }}
                                                            onClick={() => this.AcademReffSettings(1)}>Специальности</p>
                                                        <p style={{ color: this.state.typeofacademSettings === 2 && '#7F9CF5' }}
                                                            onClick={() => this.AcademReffSettings(2)}>Дисциплины</p>
                                                    </span> : null}
                                            </div>
                                            <div className='search_container Student'>
                                                <input
                                                    className="search-input"
                                                    onChange={this.onChangeBoundApplication}
                                                    type="text"
                                                    pattern="^[А-Яа-яЁё\s]+$"
                                                    value={this.state.s_fio_document}
                                                    onKeyPress={this.handleKeyPress}
                                                />
                                                <label
                                                    className="search-button"
                                                    type="button"
                                                    aria-label="search button"
                                                    style={{ cursor: 'default' }}
                                                    onClick={() => this.onSearchClick()}
                                                >
                                                    <i className="fab fa-sistrix" ></i>
                                                </label>
                                                {this.state.s_fio_document && this.state.s_fio_document.length ?
                                                    <label
                                                        className="search-button"
                                                        type="button"
                                                        aria-label="search button"
                                                        onClick={this.onCloseClick}
                                                    >
                                                        <i className="fas fa-times-circle"></i>
                                                    </label> : null}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            {this.props.applicationType === 0 ?
                                <table>
                                    <thead>
                                        <tr>
                                            <th>№</th>
                                            <th style={{ width: '15%', textAlign: 'left' }}>Справка</th>
                                            <th style={{ width: '38%', textAlign: 'left' }}>На русском</th>
                                            <th style={{ width: '37%', textAlign: 'left' }}>Кыргызча</th>
                                            <th style={{ width: '8%' }}>Изменить</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Okno_dopolnitelno && Okno_dopolnitelno.length && Okno_dopolnitelno.map((item, index) => (
                                            <tr key={'SpecialList' + index} className={this.state.activerow === 1 && this.state.activerow_ind === index && 'insert_row'}>
                                                <td>{index + 1}</td>
                                                <td style={{
                                                    padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '10px' : '10px', position: 'relative',
                                                    verticalAlign: this.state.activerow === 1 && this.state.activerow_ind === index ? 'top' : 'middle'
                                                }}>
                                                    {item.coment}
                                                </td>
                                                <td style={{
                                                    padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px',
                                                    verticalAlign: this.state.activerow === 1 && this.state.activerow_ind === index ? 'top' : 'middle'
                                                }}>
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <textarea
                                                            onChange={this.onChangeAcademKG}
                                                            defaultValue={item.insert_pole}
                                                        /> : item.insert_pole
                                                    }
                                                </td>
                                                <td style={{
                                                    padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'left',
                                                    verticalAlign: this.state.activerow === 1 && this.state.activerow_ind === index ? 'top' : 'middle'
                                                }}>
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <textarea
                                                            onChange={this.onChangeAcademEN}
                                                            defaultValue={item.insert_pole_kg}
                                                        /> : item.insert_pole_kg
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        (setAcademKG || setAcademKG == '' || setAcademEN || setAcademEN == '') && this.state.activerow_ind === index ?
                                                            <i className="fas fa-save" onClick={() => this.SaveUpdatedAcademReffSets(index, item.id_okno_dopolnitelno)}></i> : null
                                                    }
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <i className="fas fa-ban" onClick={() => this.activeUpdateRow(0, -1)}></i> :
                                                        <>
                                                            <i className="far fa-edit" onClick={() => this.activeUpdateRow(1, index)}></i>
                                                            {/* <i className="far fa-trash-alt" onClick={() => this.sureDelete(index + 'DocReg')}></i> */}
                                                        </>}
                                                </td>

                                            </tr>))}
                                    </tbody>
                                </table> : null}

                            {this.props.applicationType === 1 ?
                                <table>
                                    <thead>
                                        <tr className='header_tr'>
                                            <th colSpan='5' style={{ position: 'relative' }}>
                                                {this.state.typeofacademSettings === 0 ? 'Направления' :
                                                    this.state.typeofacademSettings === 1 ? 'Специальности' :
                                                        this.state.typeofacademSettings === 2 && 'Дисциплины'}
                                                {this.props.pageStart > 0 ? <div className='page_of_page'>
                                                    {this.state.pageNum > 1 &&
                                                        <i className="fas fa-angle-left"
                                                            onClick={() => this.GoToPage(this.state.pageNum > 1 ? this.state.pageNum - 1 : 1)}></i>}
                                                    <span style={{ color: '#667EEA' }}>{`${this.props.pageStart}-${(parseInt(this.props.pageEnd) > parseInt(this.props.total)) ? this.props.total : this.props.pageEnd}`}</span>
                                                    <span>/</span>
                                                    {this.props.total}
                                                    <i className="fas fa-angle-right"
                                                        onClick={() => this.GoToPage(this.state.pageNum < this.props.pages ? this.state.pageNum + 1 : this.props.pages)}></i>
                                                </div> : null}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>№</th>
                                            <th style={{ textAlign: 'center', width: '30%' }}>Русский</th>
                                            <th style={{ textAlign: 'center', width: '30%' }}>Кыргызча</th>
                                            <th style={{ textAlign: 'center', width: '30%' }}>English</th>
                                            <th style={{ width: '8%' }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {typeofacademSettings === 1 ? SpecialList && SpecialList.length && SpecialList.map((item, index) => (
                                            <tr key={'SpecialList' + index} className={this.state.activerow === 1 && this.state.activerow_ind === index && 'insert_row'}>
                                                <td>{item.rowNum}</td>
                                                <td style={{
                                                    padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '10px' : '10px', position: 'relative',
                                                    verticalAlign: this.state.activerow === 1 && this.state.activerow_ind === index ? 'top' : 'middle'
                                                }}>
                                                    {item['p25-2']}
                                                </td>
                                                <td style={{
                                                    padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px',
                                                    verticalAlign: this.state.activerow === 1 && this.state.activerow_ind === index ? 'top' : 'middle'
                                                }}>
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <textarea
                                                            onChange={this.onChangeAcademKG}
                                                            defaultValue={item.p25_2k}
                                                        /> : item.p25_2k
                                                    }
                                                </td>
                                                <td style={{
                                                    padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'left',
                                                    verticalAlign: this.state.activerow === 1 && this.state.activerow_ind === index ? 'top' : 'middle'
                                                }}>
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <textarea
                                                            onChange={this.onChangeAcademEN}
                                                            defaultValue={item.p25_2_en}
                                                        /> : item.p25_2_en
                                                    }
                                                </td>
                                                <td >
                                                    {
                                                        (setAcademKG || setAcademEN) && this.state.activerow_ind === index ?
                                                            <i className="fas fa-save" onClick={() => this.SaveUpdatedAcademReffSets(index, item.id_special)}></i> : null
                                                    }
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <i className="fas fa-ban" onClick={() => this.activeUpdateRow(0, -1)}></i> :
                                                        <>
                                                            <i className="far fa-edit" onClick={() => this.activeUpdateRow(1, index)}></i>
                                                            {/* <i className="far fa-trash-alt" onClick={() => this.sureDelete(index + 'DocReg')}></i> */}
                                                        </>}
                                                </td>

                                            </tr>
                                        )) : typeofacademSettings === 0 ? DirectionList && DirectionList.length && DirectionList.map((item, index) => (
                                            <tr key={'DirectionList' + index} className={this.state.activerow === 1 && this.state.activerow_ind === index && 'insert_row'}>
                                                <td>{item.rowNum}</td>
                                                <td style={{
                                                    padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '10px' : '10px', position: 'relative',
                                                    verticalAlign: this.state.activerow === 1 && this.state.activerow_ind === index ? 'top' : 'middle'
                                                }}>
                                                    {item['p24-2']}
                                                </td>
                                                <td style={{
                                                    padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px',
                                                    verticalAlign: this.state.activerow === 1 && this.state.activerow_ind === index ? 'top' : 'middle'
                                                }}>
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <textarea
                                                            onChange={this.onChangeAcademKG}
                                                            defaultValue={item['p24-2_kg']}
                                                        /> : item['p24-2_kg']
                                                    }
                                                </td>
                                                <td style={{
                                                    padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'left',
                                                    verticalAlign: this.state.activerow === 1 && this.state.activerow_ind === index ? 'top' : 'middle'
                                                }}>
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <textarea
                                                            onChange={this.onChangeAcademEN}
                                                            defaultValue={item.p24_2_en}
                                                        /> : item.p24_2_en
                                                    }
                                                </td>
                                                <td >
                                                    {
                                                        (setAcademKG || setAcademEN) && this.state.activerow_ind === index ?
                                                            <i className="fas fa-save" onClick={() => this.SaveUpdatedAcademReffSets(index, item.id_direction)}></i> : null
                                                    }
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <i className="fas fa-ban" onClick={() => this.activeUpdateRow(0, -1)}></i> :
                                                        <>
                                                            <i className="far fa-edit" onClick={() => this.activeUpdateRow(1, index)}></i>
                                                            {/* <i className="far fa-trash-alt" onClick={() => this.sureDelete(index + 'DocReg')}></i> */}
                                                        </>}
                                                </td>

                                            </tr>
                                        )) : typeofacademSettings === 2 && DisciplineList && DisciplineList.length && DisciplineList.map((item, index) => (
                                            <tr key={'DisciplineList' + index} className={this.state.activerow === 1 && this.state.activerow_ind === index && 'insert_row'}>
                                                <td>{item.rowNum}</td>
                                                <td style={{
                                                    padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '10px' : '10px', position: 'relative',
                                                    verticalAlign: this.state.activerow === 1 && this.state.activerow_ind === index ? 'top' : 'middle'
                                                }}>
                                                    {item.p34}
                                                </td>
                                                <td style={{
                                                    padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px',
                                                    verticalAlign: this.state.activerow === 1 && this.state.activerow_ind === index ? 'top' : 'middle'
                                                }}>
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <textarea
                                                            onChange={this.onChangeAcademKG}
                                                            defaultValue={item.p34_kg}
                                                        /> : item.p34_kg
                                                    }
                                                </td>
                                                <td style={{
                                                    padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'left',
                                                    verticalAlign: this.state.activerow === 1 && this.state.activerow_ind === index ? 'top' : 'middle'
                                                }}>
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <textarea
                                                            onChange={this.onChangeAcademEN}
                                                            defaultValue={item.p34_en}
                                                        /> : item.p34_en
                                                    }
                                                </td>
                                                <td >
                                                    {
                                                        (setAcademKG || setAcademEN) && this.state.activerow_ind === index ?
                                                            <i className="fas fa-save" onClick={() => this.SaveUpdatedAcademReffSets(index, item.id_discipline)}></i> : null
                                                    }
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <i className="fas fa-ban" onClick={() => this.activeUpdateRow(0, -1)}></i> :
                                                        <>
                                                            <i className="far fa-edit" onClick={() => this.activeUpdateRow(1, index)}></i>
                                                            {/* <i className="far fa-trash-alt" onClick={() => this.sureDelete(index + 'DocReg')}></i> */}
                                                        </>}
                                                </td>

                                            </tr>
                                        ))
                                        }
                                    </tbody>
                                </table> : null}



                        </div> : null
                }
                {/* Меню Разрешение*/}
                {
                    this.props.selected_menu === 6 ?
                        <div className='Student_Doc_list Razreshenie'>
                            <div className='Application_container' onClick={() => this.state.application === 1 && this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)}>
                                <div className='Application_menu'>
                                    <h3 className={this.props.applicationType === 0 && 'active_left'}
                                        onClick={() => this.SelectApplicationType(0)}>Разрешение</h3>
                                    <h3 className={this.props.applicationType === 1 && 'active_right'}
                                        onClick={() => this.SelectApplicationType(1)}>Настройки</h3>
                                </div>
                                <div className='Application_instruments' >
                                    {this.props.applicationType === 0 ?
                                        <div className="selector">
                                            <h2 className="select" onClick={() => this.state.application === 0 ? this.OpenSelectorOptions(0, 0, 0, 0, 0, 1) :
                                                this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)} >
                                                {this.state.okno_role_type === 0 ? 'Студенты' :
                                                    this.state.okno_role_type === 1 && 'Сотрудники'}
                                            </h2>
                                            {this.state.application === 1 ?
                                                <span>
                                                    <p style={{ color: this.state.okno_role_type === 0 && '#7F9CF5' }}
                                                        onClick={() => this.SelectOknoRoleType(0)}>Студенты</p>
                                                    <p style={{ color: this.state.okno_role_type === 1 && '#7F9CF5' }}
                                                        onClick={() => this.SelectOknoRoleType(1)}>Сотрудники</p>
                                                </span> : null}
                                        </div> :
                                        <div>
                                            <div className="selector">
                                                <h2 className="select" onClick={() => this.state.application === 0 ? this.OpenSelectorOptions(0, 0, 0, 0, 0, 1) :
                                                    this.OpenSelectorOptions(0, 0, 0, 0, 0, 0)} >
                                                    {this.state.okno_role_type === 0 ? 'Студенты' :
                                                        this.state.okno_role_type === 1 && 'Сотрудники'}
                                                </h2>
                                                {this.state.application === 1 ?
                                                    <span>
                                                        <p style={{ color: this.state.okno_role_type === 0 && '#7F9CF5' }}
                                                            onClick={() => this.SelectOknoRoleType(0)}>Студенты</p>
                                                        <p style={{ color: this.state.okno_role_type === 1 && '#7F9CF5' }}
                                                            onClick={() => this.SelectOknoRoleType(1)}>Сотрудники</p>
                                                    </span> : null}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            {this.props.applicationType === 0 ?
                                (okno_role_type === 0 ?
                                    <table>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '3%' }}>№</th>
                                                <th style={{ width: '40%' }}>ФИО</th>
                                                {Properties && Properties[0].visibility > 0 ? <th>{Properties[0].okno_title}</th> : null}
                                                {Properties && Properties[1].visibility > 0 ? <th>{Properties[1].okno_title}</th> : null}
                                                {Properties && Properties[2].visibility > 0 ? <th>{Properties[2].okno_title}</th> : null}
                                                {Properties && Properties[3].visibility > 0 ? <th>{Properties[3].okno_title}</th> : null}
                                                {Properties && Properties[4].visibility > 0 ? <th>{Properties[4].okno_title}</th> : null}
                                                {Properties && Properties[5].visibility > 0 ? <th>{Properties[5].okno_title}</th> : null}
                                                {Properties && Properties[6].visibility > 0 ? <th>{Properties[6].okno_title}</th> : null}
                                                {Properties && Properties[7].visibility > 0 ? <th>{Properties[7].okno_title}</th> : null}
                                                {Properties && Properties[8].visibility > 0 ? <th>{Properties[8].okno_title}</th> : null}
                                                <th style={{ minWidth: '80px' }}><i className="fas fa-plus" onClick={() => this.plusInsertRow(1)}></i></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className='insert_row' style={{ position: 'relative' }} onMouseLeave={() => this.closeUserList()}>
                                                {this.state.insertRow === 1 &&
                                                    <td>#
                                                    </td>}
                                                {this.state.insertRow === 1 &&
                                                    <td style={{ position: 'relative' }}>
                                                        <input
                                                            onChange={this.onChangeUserFio}
                                                            // defaultValue={this.state.selected_s_fio}
                                                            value={this.state.selected_s_fio}
                                                            placeholder='Введите ФИО сотрудника'
                                                            onKeyPress={this.handleKeyPress}
                                                            style={{ textAlign: 'left', color: this.state.selected_s_fio && this.state.selected_s_fio.length && '#278EFF' }}
                                                        />
                                                        {this.state.new_st_fio !== null && this.state.new_st_fio !== ' ' &&
                                                            <i onClick={() => this.openUserList()} class={this.state.openUserlist === true ? "fas fa-chevron-up" : "fas fa-chevron-down"}></i>}
                                                    </td>}
                                                {this.state.insertRow === 1 && Properties && Properties[0].visibility > 0 &&
                                                    <td><input
                                                        className="checkbox"
                                                        style={{ cursor: "pointer" }}
                                                        type="checkbox"
                                                        onChange={this.ChangeProporties1}
                                                    /></td>}
                                                {this.state.insertRow === 1 && Properties && Properties[1].visibility > 0 &&
                                                    <td><input
                                                        className="checkbox"
                                                        style={{ cursor: "pointer" }}
                                                        type="checkbox"
                                                        onChange={this.ChangeProporties2}
                                                    /></td>}
                                                {this.state.insertRow === 1 && Properties && Properties[2].visibility > 0 &&
                                                    <td><input
                                                        className="checkbox"
                                                        style={{ cursor: "pointer" }}
                                                        type="checkbox"
                                                        onChange={this.ChangeProporties3}
                                                    /></td>}
                                                {this.state.insertRow === 1 && Properties && Properties[3].visibility > 0 &&
                                                    <td><input
                                                        className="checkbox"
                                                        style={{ cursor: "pointer" }}
                                                        type="checkbox"
                                                        onChange={this.ChangeProporties4}
                                                    /></td>}
                                                {this.state.insertRow === 1 && Properties && Properties[4].visibility > 0 &&
                                                    <td><input
                                                        className="checkbox"
                                                        style={{ cursor: "pointer" }}
                                                        type="checkbox"
                                                        onChange={this.ChangeProporties5}
                                                    /></td>}
                                                {this.state.insertRow === 1 && Properties && Properties[5].visibility > 0 &&
                                                    <td><input
                                                        className="checkbox"
                                                        style={{ cursor: "pointer" }}
                                                        type="checkbox"
                                                        onChange={this.ChangeProporties6}
                                                    /></td>}
                                                {this.state.insertRow === 1 && Properties && Properties[6].visibility > 0 &&
                                                    <td><input
                                                        className="checkbox"
                                                        style={{ cursor: "pointer" }}
                                                        type="checkbox"
                                                        onChange={this.ChangeProporties7}
                                                    /></td>}
                                                {this.state.insertRow === 1 && Properties && Properties[7].visibility > 0 &&
                                                    <td><input
                                                        className="checkbox"
                                                        style={{ cursor: "pointer" }}
                                                        type="checkbox"
                                                        onChange={this.ChangeProporties8}
                                                    /></td>}
                                                {this.state.insertRow === 1 && Properties && Properties[8].visibility > 0 &&
                                                    <td><input
                                                        className="checkbox"
                                                        style={{ cursor: "pointer" }}
                                                        type="checkbox"
                                                        onChange={this.ChangeProporties9}
                                                    /></td>}
                                                {this.state.insertRow === 1 &&
                                                    <td>
                                                        {selected_s_fio && Some_proporties_checked === 1 ?
                                                            <i className="fas fa-save" onClick={() => this.SaveInsertedOknoRole()}></i> : null}
                                                        <i className="fas fa-ban" onClick={() => this.plusInsertRow(0)}></i>
                                                    </td>}
                                                {this.state.openUserlist === true &&
                                                    <div className='Doc_studentList'>
                                                        {AVN_user_list && AVN_user_list.length ? AVN_user_list.map((item, index) => {
                                                            return (
                                                                <li onClick={() => this.SelectStudentFio(item.t_fio, item.id_teacher)}>
                                                                    <p>{item.t_fio}</p>
                                                                </li>
                                                            )
                                                        }) : null}
                                                    </div>
                                                }

                                            </tr>
                                            {Okno_role && Okno_role.map((item, index) => (
                                                <tr key={'raion_redact' + index} className={this.state.activerow === 1 && this.state.activerow_ind === index && 'insert_row'}>
                                                    <td>{index + 1}</td>
                                                    <td style={{ position: 'relative' }}>
                                                        {item.t_fio}
                                                    </td>
                                                    {Properties && Properties[0].visibility > 0 ?
                                                        <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'center' }}>
                                                            <label className="Application_checkbox">
                                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                    <input
                                                                        className="checkbox"
                                                                        style={{ cursor: "pointer" }}
                                                                        type="checkbox"
                                                                        onChange={this.ChangeProporties1}
                                                                        checked={ckb === true ? true : false}
                                                                    /> :
                                                                    <label className="container" >
                                                                        {item.ckb > 0 ?
                                                                            <label className="TrueTrue"
                                                                                title="Одобрено"
                                                                            /> :
                                                                            <label className="NoneNone"
                                                                                title="Не проверено"
                                                                            />}
                                                                    </label>
                                                                }
                                                            </label>
                                                        </td> : null}
                                                    {Properties && Properties[1].visibility > 0 ?
                                                        <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'center' }}>
                                                            <label className="Application_checkbox">
                                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                    <input
                                                                        className="checkbox"
                                                                        style={{ cursor: "pointer" }}
                                                                        type="checkbox"
                                                                        onChange={this.ChangeProporties2}
                                                                        checked={dekanat === true ? true : false}
                                                                    /> :
                                                                    <label className="container" >

                                                                        {item.dekanat > 0 ?
                                                                            <label className="TrueTrue"
                                                                                title="Одобрено"
                                                                            /> :
                                                                            <label className="NoneNone"
                                                                                title="Не проверено"
                                                                            />}
                                                                    </label>
                                                                }
                                                            </label>
                                                        </td> : null}
                                                    {Properties && Properties[2].visibility > 0 ?
                                                        <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'center' }}>
                                                            <label className="Application_checkbox">
                                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                    <input
                                                                        className="checkbox"
                                                                        style={{ cursor: "pointer" }}
                                                                        type="checkbox"
                                                                        onChange={this.ChangeProporties3}
                                                                        checked={KjMTB === true ? true : false}
                                                                    /> :
                                                                    <label className="container" >
                                                                        {item.KjMTB > 0 ?
                                                                            <label className="TrueTrue"
                                                                                title="Одобрено"
                                                                            /> :
                                                                            <label className="NoneNone"
                                                                                title="Не проверено"
                                                                            />}
                                                                    </label>
                                                                }
                                                            </label>
                                                        </td> : null}
                                                    {Properties && Properties[3].visibility > 0 ?
                                                        <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'center' }}>
                                                            <label className="Application_checkbox">
                                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                    <input
                                                                        className="checkbox"
                                                                        style={{ cursor: "pointer" }}
                                                                        type="checkbox"
                                                                        onChange={this.ChangeProporties4}
                                                                        checked={obshejitie === true ? true : false}
                                                                    /> :
                                                                    <label className="container" >
                                                                        {item.obshejitie > 0 ?
                                                                            <label className="TrueTrue"
                                                                                title="Одобрено"
                                                                            /> :
                                                                            <label className="NoneNone"
                                                                                title="Не проверено"
                                                                            />}
                                                                    </label>
                                                                }
                                                            </label>
                                                        </td> : null}
                                                    {Properties && Properties[4].visibility > 0 ?
                                                        <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'center' }}>
                                                            <label className="Application_checkbox">
                                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                    <input
                                                                        className="checkbox"
                                                                        style={{ cursor: "pointer" }}
                                                                        type="checkbox"
                                                                        onChange={this.ChangeProporties5}
                                                                        checked={biblioteka === true ? true : false}
                                                                    /> :
                                                                    <label className="container" >
                                                                        {item.biblioteka > 0 ?
                                                                            <label className="TrueTrue"
                                                                                title="Одобрено"
                                                                            /> :
                                                                            <label className="NoneNone"
                                                                                title="Не проверено"
                                                                            />}
                                                                    </label>
                                                                }
                                                            </label>
                                                        </td> : null}
                                                    {Properties && Properties[5].visibility > 0 ?
                                                        <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'center' }}>
                                                            <label className="Application_checkbox">
                                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                    <input
                                                                        className="checkbox"
                                                                        style={{ cursor: "pointer" }}
                                                                        type="checkbox"
                                                                        onChange={this.ChangeProporties6}
                                                                        checked={Buhgalteriy === true ? true : false}
                                                                    /> :
                                                                    <label className="container" >
                                                                        {item.Buhgalteriy > 0 ?
                                                                            <label className="TrueTrue"
                                                                                title="Одобрено"
                                                                            /> :
                                                                            <label className="NoneNone"
                                                                                title="Не проверено"
                                                                            />}
                                                                    </label>
                                                                }
                                                            </label>
                                                        </td> : null}
                                                    {Properties && Properties[6].visibility > 0 ?
                                                        <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px' }}>
                                                            <label className="Application_checkbox">
                                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                    <input
                                                                        className="checkbox"
                                                                        style={{ cursor: "pointer" }}
                                                                        type="checkbox"
                                                                        onChange={this.ChangeProporties7}
                                                                        checked={pole1 === true ? true : false}
                                                                    /> :
                                                                    <label className="container" >
                                                                        {item.pole1 > 0 ?
                                                                            <label className="TrueTrue"
                                                                                title="Одобрено"
                                                                            /> :
                                                                            <label className="NoneNone"
                                                                                title="Не проверено"
                                                                            />}
                                                                    </label>
                                                                }
                                                            </label>
                                                        </td> : null}
                                                    {Properties && Properties[7].visibility > 0 ?
                                                        <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px' }}>
                                                            <label className="Application_checkbox">
                                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                    <input
                                                                        className="checkbox"
                                                                        style={{ cursor: "pointer" }}
                                                                        type="checkbox"
                                                                        onChange={this.ChangeProporties8}
                                                                        checked={pole2 === true ? true : false}
                                                                    /> :
                                                                    <label className="container" >
                                                                        {item.pole2 > 0 ?
                                                                            <label className="TrueTrue"
                                                                                title="Одобрено"
                                                                            /> :
                                                                            <label className="NoneNone"
                                                                                title="Не проверено"
                                                                            />}
                                                                    </label>
                                                                }
                                                            </label>
                                                        </td> : null}
                                                    {Properties && Properties[8].visibility > 0 ?
                                                        <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px' }}>
                                                            <label className="Application_checkbox">
                                                                {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                    <input
                                                                        className="checkbox"
                                                                        style={{ cursor: "pointer" }}
                                                                        type="checkbox"
                                                                        onChange={this.ChangeProporties9}
                                                                        checked={pole3 === true ? true : false}
                                                                    /> :
                                                                    <label className="container" >
                                                                        {item.pole3 > 0 ?
                                                                            <label className="TrueTrue"
                                                                                title="Одобрено"
                                                                            /> :
                                                                            <label className="NoneNone"
                                                                                title="Не проверено"
                                                                            />}
                                                                    </label>
                                                                }
                                                            </label>
                                                        </td> : null}

                                                    <td >
                                                        {
                                                            Some_proporties_checked === 1 && this.state.activerow_ind === index ?
                                                                <i className="fas fa-save" onClick={() => this.SaveUpdatedOknoRole(index, item.id_role_okno)}></i> : null
                                                        }
                                                        {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                            <i className="fas fa-ban" onClick={() => this.activeUpdateRow(0, index)}></i> :
                                                            <>
                                                                <i className="far fa-edit" onClick={() => this.activeUpdateRow(1, index)}></i>
                                                                <i className="far fa-trash-alt" onClick={() => this.sureDelete(index + 'OknoRole')}></i>
                                                            </>}
                                                    </td>
                                                    {
                                                        this.state.SureDel === index + 'OknoRole' &&
                                                        <div className="Delet_Sure">
                                                            <p>
                                                                <span>Вы действительно хотите удалить запись-</span>
                                                                {item.t_fio}
                                                            </p>
                                                            <label
                                                                className="save_button"
                                                                onClick={() =>
                                                                    this.SureDeleteOknoRole(item.id_role_okno)
                                                                }
                                                            >
                                                                <i className="fas fa-trash-alt"> </i>Удалить
                                                            </label>
                                                            <label
                                                                className="cancel_button"
                                                                onClick={() => this.sureDelete(-1)}
                                                            >
                                                                <i className="fas fa-ban"></i>Отмена
                                                            </label>
                                                        </div>
                                                    }


                                                </tr>
                                            ))
                                            }
                                        </tbody>
                                    </table> :
                                    okno_role_type === 1 ?
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '3%' }}>№</th>
                                                    <th style={{ width: '40%' }}>ФИО</th>
                                                    {PropertiesTeacher && PropertiesTeacher[0] && PropertiesTeacher[0].visibility > 0 ? <th>{PropertiesTeacher[0].okno_title}</th> : null}
                                                    {PropertiesTeacher && PropertiesTeacher[1] && PropertiesTeacher[1].visibility > 0 ? <th>{PropertiesTeacher[1].okno_title}</th> : null}
                                                    {PropertiesTeacher && PropertiesTeacher[2] && PropertiesTeacher[2].visibility > 0 ? <th>{PropertiesTeacher[2].okno_title}</th> : null}
                                                    {PropertiesTeacher && PropertiesTeacher[3] && PropertiesTeacher[3].visibility > 0 ? <th>{PropertiesTeacher[3].okno_title}</th> : null}
                                                    {PropertiesTeacher && PropertiesTeacher[4] && PropertiesTeacher[4].visibility > 0 ? <th>{PropertiesTeacher[4].okno_title}</th> : null}
                                                    {PropertiesTeacher && PropertiesTeacher[5] && PropertiesTeacher[5].visibility > 0 ? <th>{PropertiesTeacher[5].okno_title}</th> : null}
                                                    {PropertiesTeacher && PropertiesTeacher[6] && PropertiesTeacher[6].visibility > 0 ? <th>{PropertiesTeacher[6].okno_title}</th> : null}
                                                    {PropertiesTeacher && PropertiesTeacher[7] && PropertiesTeacher[7].visibility > 0 ? <th>{PropertiesTeacher[7].okno_title}</th> : null}
                                                    {PropertiesTeacher && PropertiesTeacher[8] && PropertiesTeacher[8].visibility > 0 ? <th>{PropertiesTeacher[8].okno_title}</th> : null}
                                                    <th style={{ minWidth: '80px' }}><i className="fas fa-plus" onClick={() => this.plusInsertRow(1)}></i></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className='insert_row' style={{ position: 'relative' }} onMouseLeave={() => this.closeUserList()}>
                                                    {this.state.insertRow === 1 &&
                                                        <td>#
                                                        </td>}
                                                    {this.state.insertRow === 1 &&
                                                        <td style={{ position: 'relative' }}>
                                                            <input
                                                                onChange={this.onChangeUserFio}
                                                                // defaultValue={this.state.selected_s_fio}
                                                                value={this.state.selected_s_fio}
                                                                placeholder='Введите ФИО сотрудника'
                                                                onKeyPress={this.handleKeyPress}
                                                                style={{ textAlign: 'left', color: this.state.selected_s_fio && this.state.selected_s_fio.length && '#278EFF' }}
                                                            />
                                                            {this.state.new_st_fio !== null && this.state.new_st_fio !== ' ' &&
                                                                <i onClick={() => this.openUserList()} class={this.state.openUserlist === true ? "fas fa-chevron-up" : "fas fa-chevron-down"}></i>}
                                                        </td>}
                                                    {this.state.insertRow === 1 && PropertiesTeacher && PropertiesTeacher[0] && PropertiesTeacher[0].visibility > 0 &&
                                                        <td><input
                                                            className="checkbox"
                                                            style={{ cursor: "pointer" }}
                                                            type="checkbox"
                                                            onChange={this.ChangeProporties1}
                                                        /></td>}
                                                    {this.state.insertRow === 1 && PropertiesTeacher && PropertiesTeacher[1] && PropertiesTeacher[1].visibility > 0 &&
                                                        <td><input
                                                            className="checkbox"
                                                            style={{ cursor: "pointer" }}
                                                            type="checkbox"
                                                            onChange={this.ChangeProporties2}
                                                        /></td>}
                                                    {this.state.insertRow === 1 && PropertiesTeacher && PropertiesTeacher[2] && PropertiesTeacher[2].visibility > 0 &&
                                                        <td><input
                                                            className="checkbox"
                                                            style={{ cursor: "pointer" }}
                                                            type="checkbox"
                                                            onChange={this.ChangeProporties3}
                                                        /></td>}
                                                    {this.state.insertRow === 1 && PropertiesTeacher && PropertiesTeacher[3] && PropertiesTeacher[3].visibility > 0 &&
                                                        <td><input
                                                            className="checkbox"
                                                            style={{ cursor: "pointer" }}
                                                            type="checkbox"
                                                            onChange={this.ChangeProporties4}
                                                        /></td>}
                                                    {this.state.insertRow === 1 && PropertiesTeacher && PropertiesTeacher[4] && PropertiesTeacher[4].visibility > 0 &&
                                                        <td><input
                                                            className="checkbox"
                                                            style={{ cursor: "pointer" }}
                                                            type="checkbox"
                                                            onChange={this.ChangeProporties5}
                                                        /></td>}
                                                    {this.state.insertRow === 1 && PropertiesTeacher && PropertiesTeacher[5] && PropertiesTeacher[5].visibility > 0 &&
                                                        <td><input
                                                            className="checkbox"
                                                            style={{ cursor: "pointer" }}
                                                            type="checkbox"
                                                            onChange={this.ChangeProporties6}
                                                        /></td>}
                                                    {this.state.insertRow === 1 && PropertiesTeacher && PropertiesTeacher[6] && PropertiesTeacher[6].visibility > 0 &&
                                                        <td><input
                                                            className="checkbox"
                                                            style={{ cursor: "pointer" }}
                                                            type="checkbox"
                                                            onChange={this.ChangeProporties7}
                                                        /></td>}
                                                    {this.state.insertRow === 1 && PropertiesTeacher && PropertiesTeacher[7] && PropertiesTeacher[7].visibility > 0 &&
                                                        <td><input
                                                            className="checkbox"
                                                            style={{ cursor: "pointer" }}
                                                            type="checkbox"
                                                            onChange={this.ChangeProporties8}
                                                        /></td>}
                                                    {this.state.insertRow === 1 && PropertiesTeacher && PropertiesTeacher[8] && PropertiesTeacher[8].visibility > 0 &&
                                                        <td><input
                                                            className="checkbox"
                                                            style={{ cursor: "pointer" }}
                                                            type="checkbox"
                                                            onChange={this.ChangeProporties9}
                                                        /></td>}
                                                    {this.state.insertRow === 1 &&
                                                        <td>
                                                            {selected_s_fio && Some_proporties_checked === 1 ?
                                                                <i className="fas fa-save" onClick={() => this.SaveInsertedOknoRole()}></i> : null}
                                                            <i className="fas fa-ban" onClick={() => this.plusInsertRow(0)}></i>
                                                        </td>}
                                                    {this.state.openUserlist === true &&
                                                        <div className='Doc_studentList'>
                                                            {AVN_user_list && AVN_user_list.length ? AVN_user_list.map((item, index) => {
                                                                return (
                                                                    <li onClick={() => this.SelectStudentFio(item.t_fio, item.id_teacher)}>
                                                                        <p>{item.t_fio}</p>
                                                                    </li>
                                                                )
                                                            }) : null}
                                                        </div>
                                                    }

                                                </tr>
                                                {Okno_role_teacher && Okno_role_teacher.map((item, index) => (
                                                    <tr key={'raion_redact' + index} className={this.state.activerow === 1 && this.state.activerow_ind === index && 'insert_row'}>
                                                        <td>{index + 1}</td>
                                                        <td style={{ position: 'relative' }}>
                                                            {item.t_fio}
                                                        </td>
                                                        {PropertiesTeacher && PropertiesTeacher[0] && PropertiesTeacher[0].visibility > 0 ?
                                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'center' }}>
                                                                <label className="Application_checkbox">
                                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                        <input
                                                                            className="checkbox"
                                                                            style={{ cursor: "pointer" }}
                                                                            type="checkbox"
                                                                            onChange={this.ChangeProporties1}
                                                                            checked={ckb === true ? true : false}
                                                                        /> :
                                                                        <label className="container" >
                                                                            {item.t_fio_pole1 > 0 ?
                                                                                <label className="TrueTrue"
                                                                                    title="Одобрено"
                                                                                /> :
                                                                                <label className="NoneNone"
                                                                                    title="Не проверено"
                                                                                />}
                                                                        </label>
                                                                    }
                                                                </label>
                                                            </td> : null}
                                                        {PropertiesTeacher && PropertiesTeacher[1] && PropertiesTeacher[1].visibility > 0 ?
                                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'center' }}>
                                                                <label className="Application_checkbox">
                                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                        <input
                                                                            className="checkbox"
                                                                            style={{ cursor: "pointer" }}
                                                                            type="checkbox"
                                                                            onChange={this.ChangeProporties2}
                                                                            checked={dekanat === true ? true : false}
                                                                        /> :
                                                                        <label className="container" >

                                                                            {item.t_fio_pole2 > 0 ?
                                                                                <label className="TrueTrue"
                                                                                    title="Одобрено"
                                                                                /> :
                                                                                <label className="NoneNone"
                                                                                    title="Не проверено"
                                                                                />}
                                                                        </label>
                                                                    }
                                                                </label>
                                                            </td> : null}
                                                        {PropertiesTeacher && PropertiesTeacher[2] && PropertiesTeacher[2].visibility > 0 ?
                                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'center' }}>
                                                                <label className="Application_checkbox">
                                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                        <input
                                                                            className="checkbox"
                                                                            style={{ cursor: "pointer" }}
                                                                            type="checkbox"
                                                                            onChange={this.ChangeProporties3}
                                                                            checked={KjMTB === true ? true : false}
                                                                        /> :
                                                                        <label className="container" >
                                                                            {item.t_fio_pole3 > 0 ?
                                                                                <label className="TrueTrue"
                                                                                    title="Одобрено"
                                                                                /> :
                                                                                <label className="NoneNone"
                                                                                    title="Не проверено"
                                                                                />}
                                                                        </label>
                                                                    }
                                                                </label>
                                                            </td> : null}
                                                        {PropertiesTeacher && PropertiesTeacher[3] && PropertiesTeacher[3].visibility > 0 ?
                                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'center' }}>
                                                                <label className="Application_checkbox">
                                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                        <input
                                                                            className="checkbox"
                                                                            style={{ cursor: "pointer" }}
                                                                            type="checkbox"
                                                                            onChange={this.ChangeProporties4}
                                                                            checked={obshejitie === true ? true : false}
                                                                        /> :
                                                                        <label className="container" >
                                                                            {item.t_fio_pole4 > 0 ?
                                                                                <label className="TrueTrue"
                                                                                    title="Одобрено"
                                                                                /> :
                                                                                <label className="NoneNone"
                                                                                    title="Не проверено"
                                                                                />}
                                                                        </label>
                                                                    }
                                                                </label>
                                                            </td> : null}
                                                        {PropertiesTeacher && PropertiesTeacher[4] && PropertiesTeacher[4].visibility > 0 ?
                                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'center' }}>
                                                                <label className="Application_checkbox">
                                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                        <input
                                                                            className="checkbox"
                                                                            style={{ cursor: "pointer" }}
                                                                            type="checkbox"
                                                                            onChange={this.ChangeProporties5}
                                                                            checked={biblioteka === true ? true : false}
                                                                        /> :
                                                                        <label className="container" >
                                                                            {item.t_fio_pole5 > 0 ?
                                                                                <label className="TrueTrue"
                                                                                    title="Одобрено"
                                                                                /> :
                                                                                <label className="NoneNone"
                                                                                    title="Не проверено"
                                                                                />}
                                                                        </label>
                                                                    }
                                                                </label>
                                                            </td> : null}
                                                        {PropertiesTeacher && PropertiesTeacher[5] && PropertiesTeacher[5].visibility > 0 ?
                                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'center' }}>
                                                                <label className="Application_checkbox">
                                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                        <input
                                                                            className="checkbox"
                                                                            style={{ cursor: "pointer" }}
                                                                            type="checkbox"
                                                                            onChange={this.ChangeProporties6}
                                                                            checked={Buhgalteriy === true ? true : false}
                                                                        /> :
                                                                        <label className="container" >
                                                                            {item.t_fio_pole6 > 0 ?
                                                                                <label className="TrueTrue"
                                                                                    title="Одобрено"
                                                                                /> :
                                                                                <label className="NoneNone"
                                                                                    title="Не проверено"
                                                                                />}
                                                                        </label>
                                                                    }
                                                                </label>
                                                            </td> : null}
                                                        {PropertiesTeacher && PropertiesTeacher[6] && PropertiesTeacher[6].visibility > 0 ?
                                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px' }}>
                                                                <label className="Application_checkbox">
                                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                        <input
                                                                            className="checkbox"
                                                                            style={{ cursor: "pointer" }}
                                                                            type="checkbox"
                                                                            onChange={this.ChangeProporties7}
                                                                            checked={pole1 === true ? true : false}
                                                                        /> :
                                                                        <label className="container" >
                                                                            {item.t_fio_pole7 > 0 ?
                                                                                <label className="TrueTrue"
                                                                                    title="Одобрено"
                                                                                /> :
                                                                                <label className="NoneNone"
                                                                                    title="Не проверено"
                                                                                />}
                                                                        </label>
                                                                    }
                                                                </label>
                                                            </td> : null}
                                                        {PropertiesTeacher && PropertiesTeacher[7] && PropertiesTeacher[7].visibility > 0 ?
                                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px' }}>
                                                                <label className="Application_checkbox">
                                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                        <input
                                                                            className="checkbox"
                                                                            style={{ cursor: "pointer" }}
                                                                            type="checkbox"
                                                                            onChange={this.ChangeProporties8}
                                                                            checked={pole2 === true ? true : false}
                                                                        /> :
                                                                        <label className="container" >
                                                                            {item.t_fio_pole8 > 0 ?
                                                                                <label className="TrueTrue"
                                                                                    title="Одобрено"
                                                                                /> :
                                                                                <label className="NoneNone"
                                                                                    title="Не проверено"
                                                                                />}
                                                                        </label>
                                                                    }
                                                                </label>
                                                            </td> : null}
                                                        {PropertiesTeacher && PropertiesTeacher[8] && PropertiesTeacher[8].visibility > 0 ?
                                                            <td style={{ padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px' }}>
                                                                <label className="Application_checkbox">
                                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                        <input
                                                                            className="checkbox"
                                                                            style={{ cursor: "pointer" }}
                                                                            type="checkbox"
                                                                            onChange={this.ChangeProporties9}
                                                                            checked={pole3 === true ? true : false}
                                                                        /> :
                                                                        <label className="container" >
                                                                            {item.t_fio_pole9 > 0 ?
                                                                                <label className="TrueTrue"
                                                                                    title="Одобрено"
                                                                                /> :
                                                                                <label className="NoneNone"
                                                                                    title="Не проверено"
                                                                                />}
                                                                        </label>
                                                                    }
                                                                </label>
                                                            </td> : null}

                                                        <td >
                                                            {
                                                                Some_proporties_checked === 1 && this.state.activerow_ind === index ?
                                                                    <i className="fas fa-save" onClick={() => this.SaveUpdatedOknoRole(index, item.id_okno_role_teacher)}></i> : null
                                                            }
                                                            {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                                <i className="fas fa-ban" onClick={() => this.activeUpdateRow(0, index)}></i> :
                                                                <>
                                                                    <i className="far fa-edit" onClick={() => this.activeUpdateRow(1, index)}></i>
                                                                    <i className="far fa-trash-alt" onClick={() => this.sureDelete(index + 'OknoRole')}></i>
                                                                </>}
                                                        </td>
                                                        {
                                                            this.state.SureDel === index + 'OknoRole' &&
                                                            <div className="Delet_Sure">
                                                                <p>
                                                                    <span>Вы действительно хотите удалить запись-</span>
                                                                    {item.t_fio}
                                                                </p>
                                                                <label
                                                                    className="save_button"
                                                                    onClick={() =>
                                                                        this.SureDeleteOknoRole(item.id_okno_role_teacher)
                                                                    }
                                                                >
                                                                    <i className="fas fa-trash-alt"> </i>Удалить
                                                                </label>
                                                                <label
                                                                    className="cancel_button"
                                                                    onClick={() => this.sureDelete(-1)}
                                                                >
                                                                    <i className="fas fa-ban"></i>Отмена
                                                                </label>
                                                            </div>
                                                        }


                                                    </tr>
                                                ))
                                                }
                                            </tbody>
                                        </table> : null)
                                : null}

                            {this.props.applicationType === 1 ?
                                <table className='Okno_proporties_list'>
                                    <thead>
                                        {/* <tr className='header_tr'>
                                        <th colSpan='5' style={{ position: 'relative' }}>
                                            {this.state.typeofacademSettings === 0 ? 'Направления' :
                                                this.state.typeofacademSettings === 1 ? 'Специальности' :
                                                    this.state.typeofacademSettings === 2 && 'Дисциплины'}
                                        </th>
                                    </tr> */}
                                        <tr>
                                            <th style={{ width: '4%' }}>№</th>
                                            <th style={{ textAlign: 'center', width: '35%' }}>Наименование</th>
                                            <th style={{ textAlign: 'center', width: '12%' }}>Поле</th>
                                            <th style={{ textAlign: 'center', width: '25%' }}>Описание</th>
                                            <th style={{ width: '12%' }}>Видимость</th>
                                            <th style={{ width: '8%' }}>Изменить</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Okno_proporties_list && Okno_proporties_list.length && Okno_proporties_list.filter(array => array.sotrudnik === (this.state.okno_role_type === 0 ? false : true)).map((item, index) => (
                                            <tr key={'Okno_proporties_list' + index} className={this.state.activerow === 1 && this.state.activerow_ind === index && 'insert_row'}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <input
                                                            type='text'
                                                            onChange={this.onChange_okno_title}
                                                            defaultValue={item.okno_title}
                                                            style={{ textAlign: 'left' }}
                                                        /> : item.okno_title
                                                    }
                                                </td>
                                                <td style={{ textAlign: 'center', color: '#3182CE' }}>
                                                    {item.okno_pole}
                                                </td>
                                                <td style={{
                                                    padding: this.state.activerow === 1 && this.state.activerow_ind === index ? '0' : '10px', textAlign: 'left',
                                                    verticalAlign: this.state.activerow === 1 && this.state.activerow_ind === index ? 'top' : 'middle'
                                                }}>
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <input
                                                            type='text'
                                                            onChange={this.onChange_Description}
                                                            defaultValue={item.Description}
                                                            style={{ textAlign: 'left' }}
                                                        /> : item.Description
                                                    }
                                                </td>
                                                <td >
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <input
                                                            className="checkbox"
                                                            style={{ cursor: "pointer" }}
                                                            type="checkbox"
                                                            onChange={this.Change_visibility}
                                                            checked={this.state.visibility === true ? true : false}
                                                        /> :
                                                        <label className="container" >
                                                            {item.visibility > 0 ?
                                                                <label className="TrueTrue"
                                                                    title="Одобрено"
                                                                /> :
                                                                <label className="NoneNone"
                                                                    title="Не проверено"
                                                                />}
                                                        </label>
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        (this.state.okno_title_new || this.state.okno_Description_new || this.state.Some_proporties_checked === 1) && this.state.activerow_ind === index ?
                                                            <i className="fas fa-save" onClick={() => this.SaveUpdatedOknoProporties(index, item.id_okno_properties)}></i> : null
                                                    }
                                                    {this.state.activerow === 1 && this.state.activerow_ind === index ?
                                                        <i className="fas fa-ban" onClick={() => this.activeUpdateRow(0, -1)}></i> :
                                                        <>
                                                            <i className="far fa-edit" onClick={() => this.activeUpdateRow(1, index)}></i>
                                                            {/* <i className="far fa-trash-alt" onClick={() => this.sureDelete(index + 'DocReg')}></i> */}
                                                        </>}
                                                </td>

                                            </tr>))}
                                    </tbody>
                                </table> : null}



                        </div> : null
                }

            </div>

        )
    }
}
